import {
  navigate,
  navigateScreenAware,
  navigationIsSelected,
  navigationRef,
  push,
  replace,
} from 'components/Navigation/navigationRef';
import { ModalScreens, Screens, Stacks } from 'components/Navigation/types';
import { addYears, format, parseISO } from 'date-fns';
import {
  API_DATE_FORMAT,
  API_TIME_FORMAT,
  ScreenSize,
  UI_DATE_FORMAT_LONG,
} from 'lib/constants';
import { isCancelled, isError } from 'lib/isError';
import { limitDateToRange } from 'lib/limitDateToRange';
import { pluralise } from 'lib/pluralise';
import {
  filterArrayEmpty,
  getAseResultKey,
  getScreenSize,
  dateToNumber,
  randomKey,
  mapObjectValues,
} from 'lib/riskbase';
import { apiPost, apiPut } from 'service/api';
import * as http from 'service/api/constants';
import {
  CATCH_ERROR,
  doAsesAssessmentLoad,
  doFilesLoad,
  doOrgLocalMergeData,
} from 'store/actions';
import {
  ALERT,
  ALERT_ERROR,
  doFilePreviewPdf,
  doFileShare,
  doToast,
  eventTypeScrollToItem,
  HIDE_BLOCKING_LOADER,
  NAVIGATE_MODAL,
  NAVIGATE_MODAL_BACK,
  SHOW_BLOCKING_LOADER,
} from 'store/app/actions';
import {
  doAseCreateAction,
  doAseCreateControl,
  CLOSE_ASSESSMENT,
  COPY_ASSESSMENT,
  CREATE_ASSESSMENT,
  CREATE_ASSESSMENT_STEP1,
  doAseDeleteAction,
  doAseDeleteQuestionResult,
  DELETE_ASSESSMENT,
  doAseDeleteControl,
  doAseFieldInstanceAddAction,
  doAseFieldInstanceAddExistingModal,
  doAseFieldInstanceAddManyExisting,
  doAseFieldInstanceDelete,
  doAseFieldInstanceSave,
  doAseFieldInstanceSearchBarcodeForGroup,
  doAseFieldInstanceSearchPin,
  doAseFieldResultsSave,
  doAseOpenAction,
  LOAD_ASSESSMENT,
  doAseLoadPdf,
  doAseReviewAction,
  doAseReviewControl,
  doAseSetQuestionResult,
  doAseSaveAssetDetails,
  doAseSetChecklistItemResults,
  doAseUpdateSection,
  doAseSaveSummary,
  SUBMIT_ASSESSMENT,
  UNLOAD_ASSESSMENT,
  doAseUpdateAction,
  doAseUpdateControl,
  doAseOpenFieldInstance,
  doAseOpenControl,
  doAseFieldInstanceAddControl,
  doAseMakeSuggestion,
  doAseMergeTemplateSuggested,
  doAseOpenQuestion,
  doAseOpenSection,
  doAseLoadPlans,
  doAseFieldInstanceUnlink,
  doAseFieldInstanceRelink,
  doAseMergeResults,
  doAseApprove,
  doAseLoadDataFromNewApi,
  doAseUnapprove,
  doAseUnsubmit,
  doAseLightFieldInstanceDelete,
  doAseLightFieldInstanceUndelete,
  doAseReorderChildGroups,
  doAseSetChildGroups,
  doAseUpdateQuestion,
  doAseOpenInstanceCheck,
  doAseUpdateInstanceCheckResult,
  doAseFieldInstanceDuplicate,
  doAseOpenAssetFiles,
  doAseFieldInstanceSearchBarcode,
  doAseLoadElementPdf,
  doAseSetFlagResult,
  doAseLoadBundleZip,
  doAseSaveSignatory,
  doAseDeleteSignatory,
  doAseDownloadElementPdfsZip,
  doAseApprovePrecheck,
  doAseShowValidationErrors,
  doAseOpenFindingLocationModal,
} from 'store/assessments/actions';
import {
  selectAseActionAstAse,
  selectAseFieldInstanceAseMerged,
  selectAseFieldInstancesAst,
  selectAseFieldInstancesForGroup,
  selectAseAssetId,
  selectAseComplianceSubtype,
  selectAseTplFieldGroup,
  selectAseId,
  selectAseAssetAse,
  selectAseResults,
  selectAseTemplate,
  selectAseChecklistItemForQuestion,
  selectAseControlAstAse,
  selectAseQuestionLinkedItems,
  selectAseQuestionCanBeChanged,
  selectAseResultQuestion,
  selectAseTplQuestion,
  selectAseVisibleQuestionResults,
  selectAseFieldInstanceAse,
  selectAseOrganisationId,
  selectAseFieldInstanceLinkedItems,
  selectAseAssetPlans,
  selectAseIsOnline,
  selectAseFieldInstanceAst,
  selectAseTplFieldToGroupId,
  selectAseFieldResultsAstAse,
  selectAseFieldInstancesAse,
  selectAseActionPreviousParent,
  selectAseControlPreviousParent,
  selectAseFieldInstanceChildInstanceIsInParentAstAse,
  selectAseFieldInstanceAstAse,
  selectAseFeatures,
  selectAseFieldInstancesAstAseMerged,
  selectAseTemplateFieldFieldsConfig,
  selectAseResultChecklistItemsForQuestion,
  selectAseResultQuestionAnswerId,
  selectAseQuestionComment,
  selectAseFieldInstanceAstAseMerged,
  selectAseAllowedAuthorOrganisations,
  selectAseFilesAst,
  selectAseFieldInstanceNextDraftAutoIdForGroup,
  selectAseFieldInstanceWithQrCode,
  selectAseTplSignatories,
  selectAseSignatoryResults,
  selectAseDataFieldFields,
  selectAseFieldGroupsRequiredFieldValues,
  selectAseDataFieldGroups,
  selectAseFindingLocations,
} from 'store/assessments/selectors';
import { FieldTypes, File } from 'store/assets/types';
import {
  selectAsset,
  selectAssetAssessments,
  selectAssetOrganisationId,
} from 'store/assets/selectors';
import {
  selectUser,
  selectUserOrganisationFeatures,
  selectUserReference,
} from 'store/auth/selectors';
import {
  SET_ASSET_DELTA,
  doAssetUpdateListItemComplianceSummary,
} from 'store/changes/actions';
import { AssessmentDelta } from 'store/changes/types';
import {
  selectOrganisation,
  selectOrganisationAssessmentTemplate,
} from 'store/organisations/selectors';
import {
  all,
  call,
  put,
  race,
  select,
  take,
  takeEvery,
} from 'typed-redux-saga';
import {
  AppContextEnum,
  AssessmentQuestionType,
  AssessmentStatusesEnum,
  FieldRepeatableOrderEnum,
  FieldResult,
  FilesContextEnum,
  UUID,
  eventKeyAseScrollToItemInstanceExplorer,
} from 'types/types';
import { Action as ReduxAction } from 'typesafe-actions';
import { v4 as uuid } from 'uuid';
import { doLoadPlans } from 'store/plan/actions';
import { cloneDeep, difference, orderBy, toNumber, union } from 'lodash';
import {
  AseFieldResult,
  EPAssessmentApprove,
  EPAssessmentCreateAction,
  EPAssessmentCreateControl,
  EPAssessmentDeleteAction,
  EPAssessmentDeleteControl,
  EPAssessmentSetFlagResult,
  EPAssessmentUnapprove,
  EPAssessmentUnsubmit,
  EPAssessmentUpdateAction,
  EPAssessmentUpdateAssetDetails,
  EPAssessmentUpdateChecklist,
  EPAssessmentUpdateControl,
  EPAssessmentUpdateFieldInstanceCheck,
  EPAssessmentUpdateFields,
  EPAssessmentUpdateFieldsAddInstances,
  EPAssessmentUpdateFieldsDeleteLite,
  EPAssessmentUpdateQuestion,
  EPAssessmentUpdateSection,
  EPAssessmentUpdateSummary,
} from 'types/Endpoints/AssessmentsPhp';
import { ICONS } from 'components/Icon';
import { theme } from 'lib/theme';
import { sagaConfirm } from 'store/sagaHelpers';
import { getOptionFieldResultDisplayValues } from 'lib/fields';
import { getMergedAssetFromStorage } from 'store/assets/sagas';
import { orderBy as naturalOrderBy } from 'natural-orderby';
import { Plan } from 'store/plan/types';
import { RBFile } from 'store/files/types';
import { getFileTypeFromUntrustedExtension } from 'service/file';
import { smartText } from 'lib/str';
import delay from 'delay';
import { returnDefaultAction, returnDefaultControl } from './templates';
import {
  ActionSuggestion,
  AseFieldInstance,
  AseTplFieldField,
  AseTplFieldGroup,
  AseTplFieldSection,
  Assessment,
  AssessmentFilterGroup,
  AssessmentResults,
  AssessmentSignatory,
  InstanceParentParams,
} from './types';
import {
  getFieldGroupRequiredValuesCount,
  getFieldInstanceRequiredValuesCount,
  getRepeatableFilterKey,
  getRepeatableFilterOrderCheckValue,
  normalizeDefaultInstanceChecks,
  offlineAssetFieldInstanceToAssessment,
  offlineAssetAssessmentResultsToAssessmentResults,
  returnValidationErrors,
} from './utilities';
import { createId } from '@paralleldrive/cuid2';

const assessmentNotFoundError = "Assessment couldn't be found";

function* createAssessmentDoSave({
  assetId,
  complianceId,
  templateId,
  data,
}: {
  assetId: string;
  complianceId: string;
  templateId: string;
  data: Required<Omit<AssessmentDelta, 'findingSuggestions'>>;
  // test: AssetAssessmentResults;
}) {
  const asset = yield* getMergedAssetFromStorage(assetId);
  if (!asset) {
    throw new Error('Asset not found locally');
  }

  // const { complianceId } = data;
  const newAssessmentId = uuid();

  // Ensure assessed date and time is more than or equal to most recent assessment
  const mostRecentAssessedDate = Object.values(
    asset.assessments,
  ).reduce<null | Date>((acc, assessment) => {
    if (!assessment || assessment.complianceId !== complianceId) {
      return acc;
    }
    const date = new Date(
      `${assessment.details.assessedDate}T${assessment.details.assessedTime}`,
    );
    return !acc || acc < date ? date : acc;
  }, null);

  const assessedTimestamp = mostRecentAssessedDate
    ? limitDateToRange(
        new Date(`${data.details.assessedDate}T${data.details.assessedTime}`),
        {
          min: mostRecentAssessedDate,
        },
      )
    : new Date(`${data.details.assessedDate}T${data.details.assessedTime}`);

  const assessment = {
    ...data,
    details: {
      ...data.details,
      assessedBy: data.details.assessedBy.map((assessedBy) => ({
        id: assessedBy.id,
        email: assessedBy.email,
        name: assessedBy.name,
        role: assessedBy.role || '',
      })),
      assessedDate: format(assessedTimestamp, API_DATE_FORMAT),
      assessedTime: format(assessedTimestamp, API_TIME_FORMAT),
      authorOrganisation: data.details.authorOrganisation!,
    },
    // Data required for new assessments
    id: newAssessmentId,
    editable: true,
    templateId,
    complianceId,
    statusSummaryLabel: `Created ${format(Date.now(), UI_DATE_FORMAT_LONG)}`,
    latestApproved: false,
  };

  yield* put(
    SET_ASSET_DELTA({
      id: asset.id,
      delta: {
        assessments: {
          [newAssessmentId]: { ...assessment },
        },
      },
    }),
  );

  const existingComplianceSummary = asset.compliance_summary[complianceId];
  yield* put(
    doAssetUpdateListItemComplianceSummary({
      assetId: asset.id,
      complianceId,
      complianceSummary: {
        description: existingComplianceSummary?.description || '',
        assigned: existingComplianceSummary?.assigned || false,
        due_date: existingComplianceSummary?.due_date || null,
        status_id: 'inprogress',
      },
    }),
  );

  return newAssessmentId;
}

function* loadAssessment(
  assetId: string,
  assessmentId: string,
): Generator<unknown> {
  try {
    yield* put(SHOW_BLOCKING_LOADER());
    const asset = yield* select(selectAsset, assetId);
    const features = yield* select(
      selectUserOrganisationFeatures,
      asset.organisation_id,
    );

    const rawResults = asset.assessments[assessmentId];
    const availabilityNowTs = Date.now();
    // let assessmentLoaded = false;
    if (!rawResults) {
      throw new Error(assessmentNotFoundError);
    }
    if (!rawResults.editable) {
      throw new Error('Cannot open this assessment locally');
    }

    const assetDetails = {
      name: asset.details.name,
      customReference: asset.details.custom_reference || '',
      address1: asset.details.address1 || '',
      address2: asset.details.address2 || '',
      city: asset.details.city || '',
      county: asset.details.county || '',
      postcode: asset.details.postcode || '',
      phone: asset.details.phone || '',
      avatar: asset.details.avatar || '',
    };

    const complianceSummary = asset.compliance_summary[rawResults.complianceId];
    const task = complianceSummary
      ? {
          dueDate: complianceSummary.due_date
            ? dateToNumber(parseISO(complianceSummary.due_date))
            : null,
          description: complianceSummary.description,
        }
      : null;

    const assetPlans = Object.entries(asset.plans).reduce<
      Assessment['assetData']['plans']
    >((acc, [planId, plan]) => {
      if (plan) {
        acc[planId] = {
          id: plan.id,
          name: plan.name,
          fileId: plan.fileId,
          filePage: plan.filePage || 0,
          fileWidth: plan.fileWidth,
          fileHeight: plan.fileHeight,
          fileType: plan.fileType || 'image',
          pinCount: plan.pinCount,
        };
      }
      return acc;
    }, {});

    // Get assessment template from organisation
    const organisation = yield* select(
      selectOrganisation,
      asset.organisation_id,
    );

    const template = organisation.assessmentTemplates[rawResults.templateId];
    if (!template) {
      throw new Error(assessmentNotFoundError);
    }

    const allowedAuthors = naturalOrderBy(
      (template.allowedAuthorIds || [])
        .map((allowedAuthorId) => {
          const author = organisation.assessmentAuthors?.[allowedAuthorId];
          return author
            ? {
                id: allowedAuthorId,
                name: author.name,
                email: author.email,
              }
            : null;
        })
        .filter(filterArrayEmpty),
      (v) => v.name,
    );

    // @REMOVE after 2022-04-01 - at introduction template.complianceTypeId didn't exist
    const complianceTypeId =
      organisation.compliance_subtypes[rawResults.complianceId]!
        .compliance_type_id;

    const otherDataFields: Assessment['otherData']['fields'] = {
      sectionIds: organisation.fieldSectionIds,
      sections: mapObjectValues(
        organisation.fieldSections,
        (section): AseTplFieldSection => ({
          id: section.id,
          name: section.name,
          groupIds: section.groupIds,
        }),
      ),
      groups: Object.values(organisation.fieldSections).reduce<
        Record<string, AseTplFieldGroup>
      >(
        (acc, section) => ({
          ...acc,
          ...mapObjectValues(
            section.groups,
            (group): AseTplFieldGroup => ({
              id: group.id,
              name: group.name,
              nameSingular: group.nameSingular,
              repeatable: group.repeatable,
              fieldIds: group.fieldIds,
              autoIdZeroFill: group.autoIdZeroFill,
              autoIdPrefix: group.autoIdPrefix,
              disableAutoId: !!group.disableAutoId,
              allowPdfDownload: !!group.allowPdfDownload,
              calculated: {
                fieldsHaveCriteria: Object.values(group.fields).some(
                  (field) => !!field.criteria.length,
                ),
                requiredFieldIds: Object.values(group.fieldIds).filter(
                  (fieldId) => template.fields.fields[fieldId]?.require,
                ),
              },
            }),
          ),
        }),
        {},
      ),
      fields: Object.values(organisation.fieldSections).reduce<
        Record<string, AseTplFieldField>
      >(
        (acc, section) =>
          Object.values(section.groups).reduce(
            (acc1, group) => ({
              ...acc1,
              ...mapObjectValues(
                group.fields,
                (field): AseTplFieldField => field,
              ),
            }),
            acc,
          ),
        {},
      ),
    };

    const fieldInstanceRequiredResultsCount: Record<string, number> = {};
    const fieldGroupRequiredResultsCount: Record<string, number> = {};

    // Calculate required values for repeatable groups
    Object.values(rawResults.fieldInstances).forEach((fieldInstance) => {
      const count = getFieldInstanceRequiredValuesCount({
        assetResults:
          asset.fieldInstances[fieldInstance.instanceId]?.results ?? {},
        instance: offlineAssetFieldInstanceToAssessment(
          fieldInstance,
          availabilityNowTs,
        ),
        group: otherDataFields.groups[fieldInstance.groupId]!,
        fields: otherDataFields.fields,
      });
      fieldInstanceRequiredResultsCount[fieldInstance.instanceId] = count;
      fieldGroupRequiredResultsCount[fieldInstance.groupId] =
        (fieldGroupRequiredResultsCount[fieldInstance.groupId] ?? 0) + count;
    });

    // Calculate required values for non-repeatable groups
    Object.values(otherDataFields.groups).forEach((group) => {
      if (!group.repeatable) {
        const count = getFieldGroupRequiredValuesCount({
          assetResults: asset.fieldResults,
          results: rawResults.fieldResults,
          group,
          fields: otherDataFields.fields,
        });
        fieldGroupRequiredResultsCount[group.id] =
          (fieldGroupRequiredResultsCount[group.id] ?? 0) + count;
      }
    });

    // We have everything we need, set assessment state
    yield* put(
      LOAD_ASSESSMENT.success({
        id: assessmentId,
        isOnline: false,
        assetId: asset.id,
        organisationId: asset.organisation_id,
        showValidationErrors: false,
        results: offlineAssetAssessmentResultsToAssessmentResults(
          rawResults,
          availabilityNowTs,
        ),
        stats: {
          fieldGroupRequiredResultsCount,
          fieldInstanceRequiredResultsCount,
        },
        task,
        tempData: {
          repeatables: {},
        },
        filterGroups: Object.entries(otherDataFields.groups).reduce<
          Record<string, AssessmentFilterGroup>
        >((acc, [groupId, group]) => {
          const firstCheckId = template.fields.groups?.[groupId]?.checkIds?.[0];
          if (group.repeatable && firstCheckId) {
            // Add default for added screen
            acc[getRepeatableFilterKey(groupId, 'added')] = {
              order: firstCheckId
                ? getRepeatableFilterOrderCheckValue(
                    firstCheckId,
                    'completed',
                    'asc',
                  )
                : FieldRepeatableOrderEnum.createdAsc,
              // All others keep as default
              search: '',
              checks: {},
              requiredFields: false,
              availabilityCategories: [],
            };
            // Add default for adding screen
            acc[getRepeatableFilterKey(groupId, 'adding')] = {
              order: firstCheckId
                ? getRepeatableFilterOrderCheckValue(
                    firstCheckId,
                    'completed',
                    'asc',
                  )
                : FieldRepeatableOrderEnum.createdAsc,
              // All others keep as default
              search: '',
              checks: {},
              requiredFields: false,
              availabilityCategories: [],
            };
          }
          return acc;
        }, {}),
        features: {
          edit: rawResults.editable,
          editassetplans: features.editassetplans,
          unsubmit: false,
          approve: false,
          unapprove: false,
          downloadBundle: false,
        },
        template: {
          ...template,
          complianceTypeId,
          complianceSubtypeId: rawResults.complianceId,
          checklistItems: template.checklistItems || {},
          fields: {
            groups: mapObjectValues(
              template.fields.groups,
              (value): Assessment['template']['fields']['groups'][string] => ({
                questionIds: value.questionIds,
                checkIds: value.checkIds ?? [],
              }),
            ),
            fields: mapObjectValues(
              template.fields.fields,
              (value): Assessment['template']['fields']['fields'][string] => ({
                edit: value.edit,
                require: value.require ?? false,
              }),
            ),
          },
          fieldInstanceChecks: template.fieldInstanceChecks || {},
          // Merge new suggestion location onto old suggestion location
          actionSuggestions: {
            ...Object.entries(template.template_actions).reduce<
              Record<string, ActionSuggestion>
            >((acc, [suggestionId, suggestion]) => {
              acc[suggestionId] = {
                ...suggestion,
                cost: suggestion.cost !== undefined ? suggestion.cost : '',
              };
              return acc;
            }, {}),
            ...Object.entries(organisation.actionSuggestions || {}).reduce<
              Record<string, ActionSuggestion>
            >((acc, [suggestionId, suggestion]) => {
              acc[suggestionId] = {
                ...suggestion,
                cost: suggestion.cost !== undefined ? suggestion.cost : '',
              };
              return acc;
            }, {}),
          },
          controlSuggestions: {
            ...template.template_controls,
            ...(organisation.controlSuggestions || {}),
          },
          settings: {
            editAssetAddress: !!template.settings?.editAssetAddress,
            editAssetAvatar: !!template.settings?.editAssetAvatar,
            editAssetCustomReference:
              !!template.settings?.editAssetCustomReference,
            editAssetName: !!template.settings?.editAssetName,
            questionComments: !!template.settings?.questionComments,
            addCustomActions:
              template.settings?.addCustomActions !== undefined
                ? template.settings.addCustomActions
                : true,
            addCustomControls:
              template.settings?.addCustomControls !== undefined
                ? template.settings.addCustomControls
                : true,
          },
          flags: [],
        },
        assetData: {
          details: {
            ...assetDetails,
            reference: asset.reference,
            parentName: asset.details.parentName || '',
          },
          actions: Object.values(asset.actions).map<
            Assessment['assetData']['actions'][number]
          >((action) => ({
            ...action,
            reference: action.reference || '',
            customReference: action.customReference || '',
            fieldInstanceId: action.fieldInstanceId || null,
            cost: action.cost !== undefined ? action.cost : '',
            pin: action.pin !== undefined ? action.pin : null,
          })),
          controls: Object.values(asset.controls).map<
            Assessment['assetData']['controls'][number]
          >((control) => ({
            ...control,
            fieldInstanceId: control.fieldInstanceId || null,
          })),
          files: Object.values(asset.files).reduce<Record<string, File>>(
            (acc, file) => {
              if (file) {
                acc[file.id] = file;
              }
              return acc;
            },
            {},
          ),
          fieldResults: asset.fieldResults,
          fieldInstances: Object.entries(asset.fieldInstances).reduce<
            Record<string, AseFieldInstance>
          >((acc, [instanceId, instance]) => {
            acc[instanceId] = offlineAssetFieldInstanceToAssessment(
              instance,
              availabilityNowTs,
            );
            return acc;
          }, {}),
          fieldInstanceAutoIds: asset.fieldInstanceAutoIds || {},
          defaultInstanceChecks: normalizeDefaultInstanceChecks(
            asset.defaultInstanceChecks || {},
            availabilityNowTs,
          ),
          answers: asset.assessment_answers || {},
          assessmentTimestamps: Object.values(asset.assessments)
            .filter(
              (ase) =>
                ase?.id !== assessmentId &&
                ase?.complianceId === rawResults.complianceId,
            )
            .map((ase) =>
              dateToNumber(
                new Date(
                  `${ase!.details.assessedDate}T${ase!.details.assessedTime}`,
                ),
              ),
            ),
          riskRatings: asset.assessment_risk_ratings,
          teamResponsibility: asset.team_responsibles,
          plans: assetPlans,
        },
        otherData: {
          signatories: orderBy(
            (template.signatoryIds || []).reduce<AssessmentSignatory[]>(
              (acc, signatoryId) => {
                const signatory =
                  organisation?.assessmentSignatories?.[signatoryId];
                if (signatory) {
                  acc.push({
                    id: signatory.id,
                    name: signatory.name,
                    declaration: signatory.declaration,
                    requireOnSubmit: signatory.requireOnSubmit,
                    allowUnavailable: signatory.allowUnavailable,
                  });
                }
                return acc;
              },
              [],
            ),
            'ordering',
          ),
          allowedAuthorOrganisations:
            rawResults.config?.allowedAuthorOrganisations || [],
          allowedAuthors,
          accounts: organisation.accounts,
          teams: organisation.teams,
          assessment_statuses: organisation.assessment_statuses,
          compliance_types: organisation.compliance_types,
          compliance_sub_types: organisation.compliance_subtypes,
          categories: organisation.categories,
          due_types: organisation.due_types,
          priorities: organisation.priorities,
          secondary_priorities: organisation.secondary_priorities,
          task_statuses: organisation.task_status_ids.map(
            (id) => organisation.task_statuses[id]!,
          ),
          control_statuses: organisation.control_status_ids.map(
            (id) => organisation.control_statuses[id]!,
          ),
          fields: otherDataFields,
        },
      }),
    );

    navigationRef.current?.navigate(Screens.ROOT_ASSESSMENT, {
      assessmentId,
    });
  } catch (error) {
    if (isError(error)) {
      yield* put(ALERT_ERROR({ error }));
    }
    yield* put(LOAD_ASSESSMENT.failure());
  }
  yield* put(HIDE_BLOCKING_LOADER());
}

function* copyAssessmentSaga(
  action: ReturnType<typeof COPY_ASSESSMENT>,
): Generator<unknown> {
  yield* put(SHOW_BLOCKING_LOADER());
  try {
    const user = (yield* select(selectUser))!;
    const { assetIds } = action.payload;
    const { id: templateId, complianceSubtypeId: complianceId } =
      yield* select(selectAseTemplate);
    const results = yield* select(selectAseResults);
    const allowedAuthorOrganisations = yield* select(
      selectAseAllowedAuthorOrganisations,
    );
    let countComplete = 0;

    for (const assetId of assetIds) {
      try {
        yield* createAssessmentDoSave({
          assetId,
          complianceId,
          templateId,
          data: {
            actions: Object.fromEntries(
              Object.values(results.actions)
                .filter(filterArrayEmpty)
                .map((resultAction) => {
                  const newActionId = uuid();
                  return [
                    newActionId,
                    {
                      ...resultAction,
                      history: [],
                      id: newActionId,
                      isReview: false,
                      photoIds: [],
                      previousParents: [{ id: '1', type: 'section' }],
                      reference: '',
                      reviewNote: '',
                      reviewStatusId: null,
                      statusId: null,
                    },
                  ];
                }),
            ),
            controls: Object.fromEntries(
              Object.values(results.controls)
                .filter(filterArrayEmpty)
                .map((resultControl) => {
                  const newControlId = uuid();
                  return [
                    newControlId,
                    {
                      ...resultControl,
                      history: [],
                      id: newControlId,
                      isReview: false,
                      photoIds: [],
                      previousParents: [{ id: '1', type: 'section' }],
                      reference: '',
                      reviewNote: '',
                      reviewStatusId: null,
                    },
                  ];
                }),
            ),
            details: {
              customReference: '',
              statusId: AssessmentStatusesEnum.inprogress,
              assessedBy: [
                { id: user.id, email: user.email, name: user.name, role: '' },
              ],
              assessedDate: results.details.assessedDate,
              assessedTime: results.details.assessedTime,
              startDate: results.details.startDate,
              startDateType: results.details.startDateType,
              expiryDate: results.details.expiryDate,
              expiryDateTimescale: results.details.expiryDateTimescale,
              expiryDateType: results.details.expiryDateType,
              riskLikelihoodId: results.details.riskLikelihoodId,
              riskSeverityId: results.details.riskSeverityId,
              actionTimescaleDate: results.details.actionTimescaleDate,
              actionTimescaleUpdateReviewed:
                results.details.actionTimescaleUpdateReviewed,
              remarksAssessor: results.details.remarksAssessor,
              remarksScope: results.details.remarksScope,
              remarksScopeChange: results.details.remarksScopeChange,
              riskChangeReason: results.details.riskChangeReason,
              riskReason: results.details.riskReason,
              fileIds: [],
              approvedBy: null,
              approvedDate: null,
              risk: null,
              authorOrganisation: results.details.authorOrganisation,
            },
            asset: {},
            sections: results.sections,
            questions: results.questions,
            checklistItems: results.checklistItems,
            fieldResults: results.fieldResults,
            fieldInstances: results.fieldInstances,
            fieldInstanceChecks: results.fieldInstanceChecks,
            questionComments: results.questionComments,
            signatories: results.signatories,
            config: {
              allowedAuthorOrganisations,
            },
          },
        });
        countComplete += 1;
      } catch (error) {
        yield* put(CATCH_ERROR({ error }));
      }
    }
    yield* put(
      ALERT({
        text: `The assessment has been copied to ${pluralise(
          countComplete,
          'the chosen asset',
          '{x} assets',
        )}`,
      }),
    );
  } catch (error) {
    if (isError(error)) {
      yield* put(ALERT_ERROR({ error }));
      yield* put(CATCH_ERROR({ error }));
    }
  }
  yield* put(HIDE_BLOCKING_LOADER());
}

function* runActionsAfter(actionsAfter?: ReduxAction[]) {
  if (actionsAfter?.length) {
    yield all(
      actionsAfter.map((a) =>
        put({
          type: a.type,
          /** @ts-expect-error payload may exist */
          payload: a.payload,
        }),
      ),
    );
  }
}

function* saveAssessmentDelta(
  assessment: AssessmentDelta,
  actionsAfter?: ReduxAction[],
): Generator<unknown> {
  const assetId = yield* select(selectAseAssetId);
  const assessmentId = yield* select(selectAseId);
  // Merge change into asset delta
  yield* put(
    SET_ASSET_DELTA({
      id: assetId,
      delta: { assessments: { [assessmentId]: assessment } },
    }),
  );
  // Merge change into assessment store
  yield* put(doAseMergeResults(assessment!));
  yield* call(runActionsAfter, actionsAfter);
}

function* getModifiedChildInstances(
  parent: NonNullable<InstanceParentParams>,
  changes:
    | {
        setInstanceIds?: undefined;
        addInstanceIds: UUID[];
        removeInstanceIds: UUID[];
      }
    | {
        setInstanceIds: UUID[];
        addInstanceIds?: undefined;
        removeInstanceIds?: undefined;
      },
): Generator<
  unknown,
  | {
      fieldInstances: Record<string, AseFieldInstance>;
      fieldResults?: undefined;
    }
  | { fieldResults: Record<string, FieldResult>; fieldInstances?: undefined }
  | null
> {
  if (parent.instanceId) {
    const parentInstance =
      (yield* select(selectAseFieldInstanceAseMerged, parent.instanceId)) ||
      (yield* select(selectAseFieldInstanceAst, parent.instanceId));
    if (parentInstance) {
      const parentInstanceAse = yield* select(
        selectAseFieldInstanceAse,
        parentInstance.instanceId,
      );
      const existingParentResult = (parentInstance.results[parent.fieldId]
        ?.value || []) as string[];
      return {
        fieldInstances: {
          [parentInstance.instanceId]: {
            ...parentInstance,
            updatedTs: dateToNumber(),
            results: {
              ...(parentInstanceAse?.results || {}),
              [parent.fieldId]: {
                fieldId: parent.fieldId,
                value: changes.setInstanceIds
                  ? changes.setInstanceIds
                  : difference(
                      union(existingParentResult, changes.addInstanceIds || []),
                      changes.removeInstanceIds || [],
                    ),
                ts: dateToNumber(),
                pin: '',
                action: null,
              },
            },
          },
        },
      };
    }
    return null;
  }
  const existingParentResult = ((yield* select(selectAseFieldResultsAstAse))[
    parent.fieldId
  ]?.value || []) as string[];
  return {
    fieldResults: {
      [parent.fieldId]: {
        fieldId: parent.fieldId,
        value: changes.setInstanceIds
          ? changes.setInstanceIds
          : difference(
              union(existingParentResult, changes.addInstanceIds || []),
              changes.removeInstanceIds || [],
            ),
        pin: '',
        ts: dateToNumber(),
        action: null,
      },
    },
  };
}

function* modifyChildInstances(
  parent: NonNullable<InstanceParentParams>,
  changes:
    | {
        setInstanceIds?: undefined;
        addInstanceIds: UUID[];
        removeInstanceIds: UUID[];
      }
    | {
        setInstanceIds: UUID[];
        addInstanceIds?: undefined;
        removeInstanceIds?: undefined;
      },
) {
  const modifications = yield* getModifiedChildInstances(parent, changes);
  if (modifications) {
    yield* saveAssessmentDelta(modifications);
  }
}

export const assessmentSideEffects = [
  takeEvery(
    CREATE_ASSESSMENT_STEP1,
    function* f(action: ReturnType<typeof CREATE_ASSESSMENT_STEP1>) {
      const { assetId, complianceSubtypeId } = action.payload;

      const asset = yield* select(selectAsset, assetId);
      const organisation = yield* select(
        selectOrganisation,
        asset.organisation_id,
      );

      const complianceSubtype =
        organisation.compliance_subtypes[complianceSubtypeId]!;

      const hasAssessment = Object.values(asset.assessments).some(
        (ase) =>
          ase?.complianceId === complianceSubtypeId &&
          ase.details.statusId !== 'approved',
      );
      if (
        hasAssessment &&
        !(yield* sagaConfirm({
          confirmText: 'Create',
          text:
            `An existing ${complianceSubtype.name} has already been started.\n\n` +
            'Create a new one anyway?',
        }))
      ) {
        return;
      }

      const templates = Object.values(organisation.assessmentTemplates).filter(
        (tpl) =>
          tpl.compliance_subtype_id === complianceSubtypeId && !tpl.deleted,
      );

      if (templates.length === 1) {
        // Create assessment based on this template
        yield* put(
          CREATE_ASSESSMENT({
            assetId,
            templateId: templates[0]!.id,
          }),
        );
      } else {
        yield* put(
          NAVIGATE_MODAL({
            screen: ModalScreens.CREATEASSESSMENT,
            params: {
              assetId,
              complianceSubtypeId,
            },
          }),
        );
      }
    },
  ),
  takeEvery(CREATE_ASSESSMENT, function* f(action) {
    try {
      const { assetId, templateId } = action.payload;
      const organisationId = yield* select((state) =>
        selectAssetOrganisationId(state, assetId),
      );
      const template = yield* select((state) =>
        selectOrganisationAssessmentTemplate(state, organisationId, templateId),
      );
      const user = (yield* select(selectUser))!;
      const newAssessmentData: Required<
        Omit<AssessmentDelta, 'findingSuggestions'>
      > = {
        details: {
          customReference: '',
          statusId: AssessmentStatusesEnum.inprogress,
          assessedBy: [
            {
              email: user.email,
              id: user.reference || user.id,
              name: user.name,
              role: '',
            },
          ],
          assessedDate: format(new Date(), API_DATE_FORMAT),
          assessedTime: format(new Date(), 'HH:mm:ss'),
          startDateType: 'assessed',
          startDate: format(new Date(), API_DATE_FORMAT),
          expiryDateType: 'asset',
          expiryDate: format(addYears(new Date(), 1), API_DATE_FORMAT),
          expiryDateTimescale: null,
          actionTimescaleDate: format(new Date(), API_DATE_FORMAT),
          actionTimescaleUpdateReviewed: false,
          remarksAssessor: '',
          remarksScope: '',
          remarksScopeChange: '',
          riskLikelihoodId: '',
          riskSeverityId: '',
          riskChangeReason: false,
          riskReason: '',
          fileIds: [],
          approvedBy: null,
          approvedDate: null,
          risk: null,
          authorOrganisation: (template.allowedAuthorOrganisations || []).find(
            (o) => o.id === template.authorOrganisationId,
          ) || {
            id: '',
            name: '',
          },
        },
        asset: {},
        actions: {},
        controls: {},
        fieldInstances: {},
        fieldInstanceChecks: {},
        questionComments: {},
        checklistItems: {},
        fieldResults: {},
        questions: {},
        sections: {},
        signatories: {},
        config: {
          allowedAuthorOrganisations: template.allowedAuthorOrganisations || [],
        },
      };

      const newId = yield* createAssessmentDoSave({
        assetId,
        complianceId: template.compliance_subtype_id,
        templateId,
        data: newAssessmentData,
      });

      yield* put(
        LOAD_ASSESSMENT.request({
          assessmentId: newId,
          assetId,
        }),
      );
    } catch (error) {
      yield* put(CATCH_ERROR({ error }));
      throw error;
    }
  }),
  takeEvery(LOAD_ASSESSMENT.request, function* f(action) {
    try {
      const assessment = (yield* select(
        selectAssetAssessments,
        action.payload.assetId,
      ))[action.payload.assessmentId];
      if (!assessment?.editable) {
        /**
         * @todo check asset and asset changes to see if assessment is submitted in
         * changes but in progress in asset - a sync is required
         */
        // if (
        //   assetChangesAssessment.status_id === 'submitted' &&
        //   assetAssessment.status_id !== 'submitted'
        // ) {
        //   throw new Error(
        //     'Please sync with RiskBase before opening this assessment',
        //   );
        // }
        yield* put(doAsesAssessmentLoad({ id: action.payload.assessmentId }));
        return;
      }
      if (assessment.details.statusId !== 'inprogress') {
        throw new Error(
          'Please sync with RiskBase before opening this assessment',
        );
      }
      // Race loading the assessment with UNLOAD_ASSESSMENT which is called if the user
      // taps the close button. We don't want to continue the load / set state
      yield race({
        cancel: take(UNLOAD_ASSESSMENT),
        task: call(
          loadAssessment,
          action.payload.assetId,
          action.payload.assessmentId,
        ),
      });
    } catch (error) {
      if (isError(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
    }
  }),
  takeEvery(doAseLoadPdf, function* f(action) {
    try {
      const { live, doShare } = action.payload;
      const id = yield* select(selectAseId);
      if (doShare) {
        yield* put(
          doFileShare({
            url: live ? http.ASSESSMENT_LIVE_PDF(id) : http.ASSESSMENT_PDF(id),
          }),
        );
      } else {
        yield* put(
          doFilePreviewPdf({
            url: live ? http.ASSESSMENT_LIVE_PDF(id) : http.ASSESSMENT_PDF(id),
          }),
        );
      }
    } catch (error) {
      if (isError(error) && !isCancelled(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
      yield* put(CATCH_ERROR({ error }));
    }
  }),
  takeEvery(doAseLoadBundleZip, function* f(action) {
    try {
      const { doShare } = action.payload;
      const id = yield* select(selectAseId);
      if (doShare) {
        yield* put(
          doFileShare({
            url: http.aseElementBundleZip(id),
          }),
        );
      } else {
        yield* put(
          doFilePreviewPdf({
            url: http.aseElementBundleZip(id),
          }),
        );
      }
    } catch (error) {
      if (isError(error) && !isCancelled(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
      yield* put(CATCH_ERROR({ error }));
    }
  }),
  takeEvery(doAseLoadElementPdf, function* f(action) {
    try {
      const { doShare, elementId: element } = action.payload;
      const id = yield* select(selectAseId);
      if (doShare) {
        yield* put(
          doFileShare({
            url: http.aseElementPdf(id, element),
          }),
        );
      } else {
        yield* put(
          doFilePreviewPdf({
            url: http.aseElementPdf(id, element),
          }),
        );
      }
    } catch (error) {
      if (isError(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
      yield* put(CATCH_ERROR({ error }));
    }
  }),
  takeEvery(doAseDownloadElementPdfsZip, function* f(action) {
    try {
      const { groupId, parent } = action.payload;
      const id = yield* select(selectAseId);
      const elementIds = Object.keys(
        yield* select(selectAseFieldInstancesForGroup, {
          groupId,
          parent,
          inAssessmentOnly: true,
        }),
      );
      yield* put(
        doFileShare({
          url: http.aseElementPdfsZip(id),
          method: 'POST',
          post: {
            elementIds,
          },
        }),
      );
    } catch (error) {
      if (isError(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
      yield* put(CATCH_ERROR({ error }));
    }
  }),
  takeEvery(COPY_ASSESSMENT, copyAssessmentSaga),

  takeEvery(SUBMIT_ASSESSMENT, function* f() {
    const results = yield* select(selectAseResults);
    const { array: errorArray } = returnValidationErrors({
      groups: yield* select(selectAseDataFieldGroups),
      signatories: yield* select(selectAseTplSignatories),
      requireAllAnswers: (yield* select(selectAseTemplate)).requireAllAnswers,
      visibleQuestionResults: yield* select(selectAseVisibleQuestionResults),
      groupRequiredValues: yield* select(
        selectAseFieldGroupsRequiredFieldValues,
      ),
      signatoryResults: yield* select(selectAseSignatoryResults),
      actions: results.actions,
      controls: results.controls,
    });
    if (errorArray.length) {
      yield* put(
        ALERT({
          title:
            'Please complete all required information before submitting the assessment',
          text: `${smartText(errorArray.join('\n\n'))}`,
        }),
      );
      yield delay(1);
      yield* put(doAseShowValidationErrors(true));
      return;
    }
    if (
      !(yield* sagaConfirm({
        confirmText: 'Submit',
        text: "You won't be able to make changes to this assessment once it's submitted",
        title: 'Submit Assessment',
        titleIcon: ICONS.ForwardDuotone,
        titleIconColor: theme.colors.blue,
      }))
    ) {
      return;
    }

    yield* saveAssessmentDelta({
      details: {
        ...results.details,
        statusId: AssessmentStatusesEnum.submitted,
      },
    });

    yield* put(CLOSE_ASSESSMENT());

    yield* put(
      ALERT({
        title: 'Assessment Submitted',
        text: 'Press the green sync indicator, bottom right of the app, to ensure your assessment is synced with RiskBase',
      }),
    );
  }),

  takeEvery(DELETE_ASSESSMENT, function* f() {
    if (
      !(yield* sagaConfirm({
        title: 'Delete Assessment',
        titleColor: theme.colors.red,
        text:
          'The assessment and all information within it will be *deleted forever*.\n\n' +
          'This information cannot be recovered.',
        confirmText: 'Delete',
        destructive: true,
        delayedConfirm: true,
      }))
    ) {
      return;
    }

    if (
      !(yield* sagaConfirm({
        title: 'Please Confirm Again\nDelete Assessment',
        titleColor: theme.colors.red,
        text:
          'The assessment and all information within it will be *deleted forever*.\n\n' +
          'This information cannot be recovered.',
        confirmText: 'Delete',
        destructive: true,
        delayedConfirm: true,
      }))
    ) {
      return;
    }
    const template = yield* select(selectAseTemplate);
    const assetId = yield* select(selectAseAssetId);
    const assessmentId = yield* select(selectAseId);
    const asset = yield* select(selectAsset, assetId);
    const reference = yield* select(selectUserReference);

    yield* put(CLOSE_ASSESSMENT());
    yield delay(1);
    try {
      yield* put(
        SET_ASSET_DELTA({
          delta: {
            assessments: {
              [assessmentId]: null,
            },
          },
          id: assetId,
        }),
      );
      const existingComplianceSummary =
        asset.compliance_summary[template.complianceSubtypeId];
      yield* put(
        doAssetUpdateListItemComplianceSummary({
          assetId,
          complianceId: template.complianceSubtypeId,
          complianceSummary: {
            description: existingComplianceSummary?.description || '',
            assigned: existingComplianceSummary?.assigned || false,
            due_date: existingComplianceSummary?.due_date || null,
            // Get status of remaining assessments after deleting this assessment
            status_id: Object.values(asset.assessments).reduce(
              (out, ase) =>
                out !== 'inprogress' &&
                ase &&
                ase.id !== assessmentId &&
                ase.details.statusId !== 'approved' &&
                ase.complianceId === template.complianceSubtypeId &&
                ase.details.assessedBy.find((aB) => aB.id) === reference
                  ? ase.details.statusId
                  : out,
              'notstarted',
            ),
          },
        }),
      );
    } catch (error) {
      if (isError(error)) {
        yield* put(CATCH_ERROR({ error }));
        yield* put(ALERT_ERROR({ error }));
      }
    }
  }),

  takeEvery(doAseSaveAssetDetails, function* f(action) {
    const assetAssessment = yield* select(selectAseAssetAse);
    // const assetOriginal = yield* select(selectAssessmentAssetDetails);
    // If values are equal, remove them as custom
    const newValues = Object.fromEntries(
      Object.entries(action.payload.set).map(([key, value]) =>
        value === null || (key === 'name' && !value)
          ? // ||
            // value === assetOriginal[key as keyof typeof assetOriginal]
            [key, null]
          : [key, value],
      ),
    );
    const modifiedAsset = { ...assetAssessment, ...newValues };
    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateAssetDetails['response'],
              EPAssessmentUpdateAssetDetails['post']
            >(http.apiAseSaveAssetDetails(yield* select(selectAseId)), {
              data: newValues,
            }),
          }),
        );
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseAssetDetails]));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }

    yield* call(saveAssessmentDelta, {
      asset: modifiedAsset,
    });
  }),

  takeEvery(doAseSaveSummary, function* f(action) {
    const { data } = action.payload;

    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateSummary['response'],
              EPAssessmentUpdateSummary['post']
            >(http.apiAseSaveSummary(yield* select(selectAseId)), {
              data,
            }),
          }),
        );
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseSummary]));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }

    // yield* call(saveAssessmentDelta, {
    //   details: data,
    // });
    yield* saveAssessmentDelta({
      details: data,
    });
  }),

  takeEvery(doAseUpdateSection, function* f(action) {
    const { id: sectionId, data } = action.payload;

    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateSection['response'],
              EPAssessmentUpdateSection['post']
            >(http.apiAseSaveSection(yield* select(selectAseId), sectionId), {
              data,
            }),
          }),
        );
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseSection]));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }

    yield* call(saveAssessmentDelta, {
      sections: {
        [sectionId]: { id: sectionId, comment: data.comment },
      },
    });
  }),

  takeEvery(doAseUpdateInstanceCheckResult, function* f(action) {
    const { checkId, instanceId, remarks, statusId } = action.payload;
    const resultKey = getAseResultKey(checkId, instanceId);
    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateFieldInstanceCheck['response'],
              EPAssessmentUpdateFieldInstanceCheck['post']
            >(http.apiAseSaveFieldInstanceCheck(yield* select(selectAseId)), {
              checkId,
              instanceId,
              remarks,
              statusId,
            }),
          }),
        );
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseInstanceCheck]));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }

    yield* call(saveAssessmentDelta, {
      fieldInstanceChecks: {
        [resultKey]: { checkId, instanceId, remarks, statusId },
      },
    });
  }),

  takeEvery(doAseSetQuestionResult, function* f(action) {
    const { questionId, fieldInstanceId, answerId, comment, actionsAfter } =
      action.payload;

    const questionResultKey = getAseResultKey(questionId, fieldInstanceId);
    const currentAnswerId =
      (yield* select(
        selectAseResultQuestionAnswerId,
        questionId,
        fieldInstanceId,
      )) || '';

    const finalAnswerId = answerId !== undefined ? answerId : currentAnswerId;

    const finalComments =
      comment !== undefined
        ? comment
        : (yield* select(
            selectAseQuestionComment,
            questionId,
            fieldInstanceId,
          )) || '';

    if (yield* select(selectAseIsOnline)) {
      const blKey = randomKey();
      yield* put(SHOW_BLOCKING_LOADER(blKey));
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateQuestion['response'],
              EPAssessmentUpdateQuestion['post']
            >(
              http.apiAseSaveQuestion(
                yield* select(selectAseId),
                fieldInstanceId,
                questionId,
              ),
              {
                data: { answerId: finalAnswerId },
                comment: finalComments,
              },
            ),
          }),
        );
        yield put(HIDE_BLOCKING_LOADER(blKey));
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseQuestion]));
        yield* call(runActionsAfter, actionsAfter);
      } catch (error) {
        yield put(HIDE_BLOCKING_LOADER(blKey));
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }

    if (
      currentAnswerId !== finalAnswerId &&
      !(yield* select(
        selectAseQuestionCanBeChanged,
        questionId,
        fieldInstanceId,
      ))
    ) {
      yield* put(
        ALERT({
          text:
            'This answer cannot be changed.\n\n' +
            'Remove answers to sub-questions and try again.',
        }),
      );
      return;
    }

    yield* saveAssessmentDelta(
      {
        questions: {
          [questionResultKey]: {
            id: questionId,
            answerId: finalAnswerId,
            comment: '',
          },
        },
        questionComments: {
          [questionResultKey]: finalAnswerId ? finalComments : '',
        },
      },
      actionsAfter,
    );
  }),

  takeEvery(doAseDeleteQuestionResult, function* f(action) {
    const { questionId, fieldInstanceId } = action.payload;

    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateQuestion['response'],
              EPAssessmentUpdateQuestion['post']
            >(
              http.apiAseSaveQuestion(
                yield* select(selectAseId),
                fieldInstanceId,
                questionId,
              ),
              {
                data: { answerId: null },
                comment: '',
              },
            ),
          }),
        );
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseQuestion]));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }

    const itemsLinkedToQuestion = yield* select(
      selectAseQuestionLinkedItems,
      questionId,
      fieldInstanceId,
    );
    if (
      !(yield* sagaConfirm({
        title: 'Delete Answer',
        text: 'This will also delete any remarks, actions, controls, sub-questions/checklists linked to the question',
        confirmText: 'Delete',
        destructive: true,
      }))
    ) {
      return;
    }
    yield* call(
      saveAssessmentDelta,
      itemsLinkedToQuestion.reduce<{
        actions: Record<string, null>;
        controls: Record<string, null>;
        questions: Record<string, null>;
        checklistItems: Record<string, null>;
        questionComments: Record<string, string>;
      }>(
        (acc, item) => {
          acc[item.type][item.id] = null;
          return acc;
        },
        {
          actions: {},
          controls: {},
          questions: {},
          checklistItems: {},
          questionComments: {},
        },
      ),
    );
  }),

  takeEvery(doAseUpdateQuestion, function* f(action) {
    const {
      questionId,
      fieldInstanceId,
      answerId,
      checklistItemResults,
      comment,
      actionsAfter,
    } = action.payload;

    const question = yield* select(selectAseTplQuestion, questionId);

    if (!question) {
      return;
    }

    if (question.type === AssessmentQuestionType.checklist) {
      yield* put(
        doAseSetChecklistItemResults({
          questionId,
          fieldInstanceId,
          results: checklistItemResults,
          comment,
          actionsAfter,
        }),
      );
      return;
    }

    yield* put(
      doAseSetQuestionResult({
        questionId,
        fieldInstanceId,
        answerId,
        comment,
        actionsAfter,
      }),
    );
  }),

  takeEvery(doAseSetChecklistItemResults, function* f(action) {
    const { questionId, results, fieldInstanceId, comment, actionsAfter } =
      action.payload;

    const questionResultKey = getAseResultKey(questionId, fieldInstanceId);

    const finalResults = {
      ...(yield* select(
        selectAseResultChecklistItemsForQuestion,
        questionId,
        fieldInstanceId,
      )),
      ...results,
    };

    const finalComments =
      comment !== undefined
        ? comment
        : (yield* select(
            selectAseQuestionComment,
            questionId,
            fieldInstanceId,
          )) || '';

    const remainingResultsCount = Object.values(finalResults).filter(
      (v) => v !== null,
    ).length;

    const formattedChecklistItems = Object.entries(finalResults).reduce<
      AssessmentResults['checklistItems']
    >((acc, [checklistItemId, result]) => {
      acc[getAseResultKey(checklistItemId, fieldInstanceId)] = result
        ? {
            id: toNumber(checklistItemId),
            result,
          }
        : null;
      return acc;
    }, {});

    if (yield* select(selectAseIsOnline)) {
      const blKey = randomKey();
      yield* put(SHOW_BLOCKING_LOADER(blKey));
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateChecklist['response'],
              EPAssessmentUpdateChecklist['post']
            >(
              http.apiAseSaveChecklist(
                yield* select(selectAseId),
                fieldInstanceId,
                questionId,
              ),
              {
                data: finalResults,
                comment: finalComments,
              },
            ),
          }),
        );
        yield put(HIDE_BLOCKING_LOADER(blKey));
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseQuestion]));
        yield* call(runActionsAfter, actionsAfter);
      } catch (error) {
        yield put(HIDE_BLOCKING_LOADER(blKey));
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }

    // If no results left
    if (!remainingResultsCount) {
      const itemsLinkedToQuestion = yield* select(
        selectAseQuestionLinkedItems,
        questionId,
        fieldInstanceId,
      );
      if (
        !(yield* sagaConfirm({
          title: 'Delete Checklist',
          text: 'This is the last item in this checklist; continuing will also delete any remarks, actions and controls linked to the checklist',
          confirmText: 'Delete',
          destructive: true,
        }))
      ) {
        return;
      }
      yield* call(
        saveAssessmentDelta,
        itemsLinkedToQuestion.reduce<{
          actions: Record<string, null>;
          controls: Record<string, null>;
          questions: Record<string, null>;
          checklistItems: Record<string, null>;
          questionComments: Record<string, string>;
        }>(
          (acc, item) => {
            acc[item.type][item.id] = null;
            return acc;
          },
          {
            actions: {},
            controls: {},
            questions: {},
            checklistItems: {},
            questionComments: {},
          },
        ),
        actionsAfter,
      );
      return;
    }

    // There are other checklist items, so only delete the checklist items
    yield* call(
      saveAssessmentDelta,
      {
        checklistItems: formattedChecklistItems,
        questionComments: {
          [questionResultKey]: remainingResultsCount ? finalComments : '',
        },
      },
      actionsAfter,
    );
  }),

  takeEvery(doAseOpenSection, function* f({ payload }) {
    const { id } = payload;
    const screenSize = getScreenSize();
    if (screenSize.size === ScreenSize.small) {
      navigate(Stacks.ASSESSMENT, Screens.ASE_SECTION, {
        id,
      });
    } else {
      replace(Stacks.ASSESSMENT, Screens.ASE_SECTION, {
        id,
      });
    }
  }),

  takeEvery(doAseOpenQuestion, function* f({ payload }) {
    const { id, fieldInstanceId, parent } = payload;
    const screenSize = getScreenSize();
    if (fieldInstanceId) {
      if (screenSize.size === ScreenSize.small) {
        navigate(Stacks.ASEREPEATABLE, Screens.ASEREPEATABLE_QUESTION, {
          id,
          fieldInstanceId,
          parent,
        });
      } else {
        replace(Stacks.ASEREPEATABLE, Screens.ASEREPEATABLE_QUESTION, {
          id,
          fieldInstanceId,
          parent,
        });
      }
    } else if (screenSize.size === ScreenSize.small) {
      navigate(Stacks.ASSESSMENT, Screens.ASE_QUESTION, {
        id,
        fieldInstanceId: null,
        parent: null,
      });
    } else {
      replace(Stacks.ASSESSMENT, Screens.ASE_QUESTION, {
        id,
        fieldInstanceId: null,
        parent: null,
      });
    }
  }),

  takeEvery(doAseOpenInstanceCheck, function* f({ payload }) {
    const { id, instanceId } = payload;
    navigateScreenAware(Stacks.ASEREPEATABLE, Screens.AseInstanceCheck, {
      id,
      instanceId,
    });
  }),

  takeEvery(doAseOpenAction, function* f({ payload }) {
    const { id, parent, edit } = payload;
    const screenSize = getScreenSize();
    const isOnline = yield* select(selectAseIsOnline);
    const action = yield* select(selectAseActionAstAse, id);
    if (!action) {
      return;
    }
    if (edit && isOnline) {
      yield* put(
        NAVIGATE_MODAL({
          screen: ModalScreens.AseAction,
          params: {
            id: action.id,
            parent,
            data: action,
          },
        }),
      );
    } else if (action.fieldInstanceId) {
      if (screenSize.size === ScreenSize.small) {
        navigate(Stacks.ASEREPEATABLE, Screens.ASEREPEATABLE_ACTION, {
          id,
          parent,
          data: action,
        });
      } else {
        replace(Stacks.ASEREPEATABLE, Screens.ASEREPEATABLE_ACTION, {
          id,
          parent,
          data: action,
        });
      }
    } else if (screenSize.size === ScreenSize.small) {
      navigate(Stacks.ASSESSMENT, Screens.ASE_ACTION, {
        id,
        parent,
        data: action,
      });
    } else {
      replace(Stacks.ASSESSMENT, Screens.ASE_ACTION, {
        id,
        parent,
        data: action,
      });
    }
  }),

  takeEvery(doAseCreateAction, function* f({ payload: { data } }) {
    if (!data.description) {
      yield* put(
        ALERT({
          text: 'Please enter a description',
        }),
      );
      return;
    }

    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPost<
              EPAssessmentCreateAction['response'],
              EPAssessmentCreateAction['post']
            >(http.apiAseSaveAction(yield* select(selectAseId), null), {
              data,
            }),
          }),
        );
        yield* put(NAVIGATE_MODAL_BACK());
        yield* put(doToast('Action Created'));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }

    const id = uuid();
    const complianceSubtype = yield* select(selectAseComplianceSubtype);
    yield* call(saveAssessmentDelta, {
      actions: {
        [id]: {
          ...data,
          milestone: Date.now(),
          id,
          reference: '',
          complianceTypeId: complianceSubtype.compliance_type_id,
          complianceSubtypeId: complianceSubtype.id,
          history: [],
          isReview: false,
          reviewNote: '',
          reviewStatusId: null,
        },
      },
    });
    yield* put(NAVIGATE_MODAL_BACK());
    yield* put(doToast('Action Created'));
  }),

  takeEvery(doAseUpdateAction, function* f({ payload: { id, data } }) {
    const selectedData = yield* select(selectAseActionAstAse, id);
    if (!selectedData) {
      yield* put(
        ALERT({
          text: 'Action not found',
        }),
      );
      return;
    }
    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateAction['response'],
              EPAssessmentUpdateAction['post']
            >(http.apiAseSaveAction(yield* select(selectAseId), id), {
              data,
            }),
          }),
        );
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseAction]));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }
    yield* call(saveAssessmentDelta, {
      actions: {
        [id]: data,
      },
    });
  }),

  takeEvery(doAseReviewAction, function* f(thsAction) {
    const { id, parent, reviewStatusId } = thsAction.payload;
    const action = yield* select(selectAseActionAstAse, id);
    if (!action) {
      yield* put(
        ALERT({
          text: 'Action not found',
        }),
      );
      return;
    }
    const previousParent = yield* select(selectAseActionPreviousParent, id);
    if (previousParent.type === 'question') {
      const question = yield* select(selectAseTplQuestion, previousParent.id);
      if (question.type === AssessmentQuestionType.checklist) {
        const checklistResults = yield* select(
          selectAseChecklistItemForQuestion,
          previousParent.id,
          action.fieldInstanceId,
        );
        if (!Object.keys(checklistResults).length) {
          yield* put(
            NAVIGATE_MODAL({
              screen: ModalScreens.AseQuickAnswerChecklist,
              params: {
                instructions:
                  'Complete a checklist item to continue the action review',
                questionId: previousParent.id,
                fieldInstanceId: action.fieldInstanceId,
                actionsAfter: [thsAction],
              },
            }),
          );
          return;
        }
      } else {
        const questionResult = yield* select(
          selectAseResultQuestion,
          question.id,
          action.fieldInstanceId,
        );
        if (!questionResult) {
          yield* put(
            NAVIGATE_MODAL({
              screen: ModalScreens.AseQuickAnswerQuestion,
              params: {
                instructions:
                  'Answer this question to continue the action review',
                questionId: previousParent.id,
                fieldInstanceId: action.fieldInstanceId,
                actionsAfter: [thsAction],
              },
            }),
          );
          return;
        }
      }
    }

    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateAction['response'],
              EPAssessmentUpdateAction['post']
            >(http.apiAseSaveAction(yield* select(selectAseId), id), {
              data: {
                ...action,
                questionId:
                  previousParent.type === 'question' ? previousParent.id : null,
                sectionId:
                  previousParent.type === 'section' ? previousParent.id : null,
                reviewStatusId,
              },
            }),
          }),
        );
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }

    yield* saveAssessmentDelta({
      actions: {
        [id]: {
          ...action,
          milestone: Date.now(),
          questionId:
            previousParent.type === 'question' ? previousParent.id : null,
          sectionId:
            previousParent.type === 'section' ? previousParent.id : null,
          reviewStatusId,
        },
      },
    });

    yield* put(
      doAseOpenAction({
        id,
        parent,
      }),
    );

    yield* put(doToast('Action Reviewed'));
  }),

  takeEvery(
    doAseOpenFieldInstance,
    function* f({ payload: { instanceId, parent, scrollTo } }) {
      const instance = yield* select(selectAseFieldInstanceAse, instanceId);
      if (!instance) {
        yield* put(
          ALERT({
            text: 'Asset not found',
          }),
        );
        return;
      }
      navigateScreenAware(
        Stacks.ASEREPEATABLE,
        Screens.ASEREPEATABLE_INSTANCE,
        {
          instanceId,
          groupId: instance.groupId,
          parent,
        },
      );
      if (scrollTo) {
        yield delay(250);
        yield* put(
          eventTypeScrollToItem({
            key: eventKeyAseScrollToItemInstanceExplorer({
              assessmentId: yield* select(selectAseId),
              groupId: instance.groupId,
            }),
            item: instanceId,
            animated: true,
          }),
        );
      }
    },
  ),

  takeEvery(doAseDeleteAction, function* f({ payload: { id } }) {
    const action = yield* select(selectAseActionAstAse, id);
    if (!action) {
      yield* put(
        ALERT({
          text: 'Action not found',
        }),
      );
      return;
    }
    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPost<
              EPAssessmentDeleteAction['response'],
              EPAssessmentDeleteAction['post']
            >(http.apiAseSaveAction(yield* select(selectAseId), id, true)),
          }),
        );
        yield* put(
          doToast(action.isReview ? 'Action Review Deleted' : 'Action Deleted'),
        );
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseAction]));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }
    yield* call(saveAssessmentDelta, {
      actions: {
        [id]: null,
      },
    });
    yield* put(
      doToast(action.isReview ? 'Action Review Deleted' : 'Action Deleted'),
    );
  }),

  takeEvery(doAseOpenControl, function* f({ payload }) {
    const { id, parent, edit } = payload;
    const screenSize = getScreenSize();
    const isOnline = yield* select(selectAseIsOnline);
    const control = yield* select(selectAseControlAstAse, id);
    if (!control) {
      return;
    }
    if (edit && isOnline) {
      yield* put(
        NAVIGATE_MODAL({
          screen: ModalScreens.AseControl,
          params: {
            id: control.id,
            parent,
            data: control,
          },
        }),
      );
    } else if (control.fieldInstanceId) {
      if (screenSize.size === ScreenSize.small) {
        navigate(Stacks.ASEREPEATABLE, Screens.ASEREPEATABLE_CONTROL, {
          id,
          parent,
          data: control,
        });
      } else {
        replace(Stacks.ASEREPEATABLE, Screens.ASEREPEATABLE_CONTROL, {
          id,
          parent,
          data: control,
        });
      }
    } else if (screenSize.size === ScreenSize.small) {
      navigate(Stacks.ASSESSMENT, Screens.ASE_CONTROL, {
        id,
        parent,
        data: control,
      });
    } else {
      replace(Stacks.ASSESSMENT, Screens.ASE_CONTROL, {
        id,
        parent,
        data: control,
      });
    }
  }),

  takeEvery(doAseCreateControl, function* f({ payload: { data } }) {
    if (!data.description) {
      yield* put(
        ALERT({
          text: 'Please enter a description',
        }),
      );
      return;
    }

    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPost<
              EPAssessmentCreateControl['response'],
              EPAssessmentCreateControl['post']
            >(http.apiAseSaveControl(yield* select(selectAseId), null), {
              data,
            }),
          }),
        );
        yield* put(NAVIGATE_MODAL_BACK());
        yield* put(doToast('Control Created'));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }

    const complianceSubtype = yield* select(selectAseComplianceSubtype);
    const id = uuid();
    yield* call(saveAssessmentDelta, {
      controls: {
        [id]: {
          ...data,
          id,
          reference: '',
          complianceTypeId: complianceSubtype.compliance_type_id,
          complianceSubtypeId: complianceSubtype.id,
          history: [],
          is_review: false,
          review_note: '',
          review_status_id: null,
          milestone: Date.now(),
        },
      },
    });
    yield* put(NAVIGATE_MODAL_BACK());
    yield* put(doToast('Control Created'));
  }),

  takeEvery(doAseUpdateControl, function* f({ payload: { id, data } }) {
    const selectedData = yield* select(selectAseControlAstAse, id);
    if (!selectedData) {
      yield* put(
        ALERT({
          text: 'Control not found',
        }),
      );
      return;
    }
    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateControl['response'],
              EPAssessmentUpdateControl['post']
            >(http.apiAseSaveControl(yield* select(selectAseId), id), {
              data,
            }),
          }),
        );
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseControl]));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }
    yield* call(saveAssessmentDelta, {
      controls: {
        [id]: data,
      },
    });
  }),

  takeEvery(doAseReviewControl, function* f(thsAction) {
    const { id, parent, reviewStatusId } = thsAction.payload;
    const control = yield* select(selectAseControlAstAse, id);
    if (!control) {
      yield* put(
        ALERT({
          text: 'Control not found',
        }),
      );
      return;
    }
    const previousParent = yield* select(selectAseControlPreviousParent, id);
    if (previousParent.type === 'question') {
      const question = yield* select(selectAseTplQuestion, previousParent.id);
      if (question.type === AssessmentQuestionType.checklist) {
        const checklistResults = yield* select(
          selectAseChecklistItemForQuestion,
          previousParent.id,
          control.fieldInstanceId,
        );
        if (!Object.keys(checklistResults).length) {
          yield* put(
            NAVIGATE_MODAL({
              screen: ModalScreens.AseQuickAnswerChecklist,
              params: {
                instructions:
                  'Complete a checklist item to continue the control review',
                questionId: previousParent.id,
                fieldInstanceId: control.fieldInstanceId,
                actionsAfter: [thsAction],
              },
            }),
          );
          return;
        }
      } else {
        const questionResult = yield* select(
          selectAseResultQuestion,
          question.id,
          control.fieldInstanceId,
        );
        if (!questionResult) {
          yield* put(
            NAVIGATE_MODAL({
              screen: ModalScreens.AseQuickAnswerQuestion,
              params: {
                instructions:
                  'Answer this question to continue the control review',
                questionId: previousParent.id,
                fieldInstanceId: control.fieldInstanceId,
                actionsAfter: [thsAction],
              },
            }),
          );
          return;
        }
      }
    }

    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateControl['response'],
              EPAssessmentUpdateControl['post']
            >(http.apiAseSaveControl(yield* select(selectAseId), id), {
              data: {
                ...control,
                questionId:
                  previousParent.type === 'question' ? previousParent.id : null,
                sectionId:
                  previousParent.type === 'section' ? previousParent.id : null,
                reviewStatusId,
              },
            }),
          }),
        );
        yield* put(doToast('Control Reviewed'));
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }

    yield* saveAssessmentDelta({
      controls: {
        [id]: {
          ...control,
          milestone: Date.now(),
          questionId:
            previousParent.type === 'question' ? previousParent.id : null,
          sectionId:
            previousParent.type === 'section' ? previousParent.id : null,
          reviewStatusId,
        },
      },
    });

    yield* put(
      doAseOpenControl({
        id,
        parent,
      }),
    );

    yield* put(doToast('Control Reviewed'));
  }),

  takeEvery(doAseDeleteControl, function* f({ payload: { id } }) {
    const control = yield* select(selectAseControlAstAse, id);
    if (!control) {
      yield* put(
        ALERT({
          text: 'Control not found',
        }),
      );
      return;
    }
    if (yield* select(selectAseIsOnline)) {
      yield* put(SHOW_BLOCKING_LOADER());
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPost<
              EPAssessmentDeleteControl['response'],
              EPAssessmentDeleteControl['post']
            >(http.apiAseSaveControl(yield* select(selectAseId), id, true)),
          }),
        );
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseControl]));
        yield* put(
          doToast(
            control.isReview ? 'Control Review Deleted' : 'Control Deleted',
          ),
        );
      } catch (error) {
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      yield put(HIDE_BLOCKING_LOADER());
      return;
    }
    yield* call(saveAssessmentDelta, {
      controls: {
        [id]: null,
      },
    });
    yield* put(
      doToast(control.isReview ? 'Control Review Deleted' : 'Control Deleted'),
    );
  }),

  takeEvery(doAseMakeSuggestion, function* f(action) {
    if (yield* select(selectAseIsOnline)) {
      yield* put(
        ALERT({
          text: 'This feature is not available in QC',
        }),
      );
      return;
    }
    const {
      type,
      questionId,
      answerId,
      checklistItemId,
      description,
      why,
      categoryId,
      severityId,
      timescaleId,
      dueDeterminedBy,
      dueTimescale,
      dueTypeId,
      cost,
    } = action.payload;

    const organisationId = yield* select(selectAseOrganisationId);
    const id = createId();

    // Save data into changes for it to be synced up
    yield* call(saveAssessmentDelta, {
      findingSuggestions: {
        [id]: {
          type,
          questionId,
          answerId,
          checklistItemId,
          description,
          why,
          categoryId,
          severityId,
          timescaleId,
          dueDeterminedBy,
          dueTimescale,
          dueTypeId,
          cost,
        },
      },
    });

    // Merge onto local organisation data - this will be deleted after the user syncs
    const newData =
      type === 'action'
        ? {
            actionSuggestions: {
              [id]: {
                id,
                description,
                why,
                categoryId,
                severityId,
                timescaleId,
                dueDeterminedBy,
                dueTimescale,
                dueTypeId,
                cost,
                answerIds: answerId ? [answerId] : [],
                negativeChecklistItemIds: checklistItemId
                  ? [checklistItemId]
                  : [],
                positiveChecklistItemIds: [],
              },
            },
          }
        : {
            controlSuggestions: {
              [id]: {
                id,
                description,
                why,
                categoryId,
                questionIds: questionId ? [questionId] : [],
                negativeChecklistItemIds: [],
                positiveChecklistItemIds: checklistItemId
                  ? [checklistItemId]
                  : [],
              },
            },
          };

    // Merge into organisation - this is until sync runs
    yield* put(
      doOrgLocalMergeData({
        id: organisationId,
        data: newData,
      }),
    );

    // Merge into assessment - this is until the user closes the assessment
    yield* put(
      doAseMergeTemplateSuggested({
        actionSuggestions: newData.actionSuggestions,
        controlSuggestions: newData.controlSuggestions,
      }),
    );

    yield* put(doToast('Suggestion Created'));

    yield* put(NAVIGATE_MODAL_BACK());
  }),

  takeEvery(doAseFieldInstanceAddExistingModal, function* f(action) {
    const { instanceId, parent } = action.payload;

    const instance =
      (yield* select(selectAseFieldInstanceAst, instanceId)) ||
      (yield* select(selectAseFieldInstanceAse, instanceId));

    if (instance) {
      yield* put(
        NAVIGATE_MODAL({
          screen: ModalScreens.AseFieldInstance,
          params: {
            groupId: instance.groupId,
            isAddingExisting: true,
            instanceId: instance.instanceId,
            parent,
          },
        }),
      );
    }
  }),

  takeEvery(doAseFieldInstanceSearchBarcodeForGroup, function* f(action) {
    const { data, groupId, parent } = action.payload;
    if (!data) {
      return;
    }

    const group = yield* select(selectAseTplFieldGroup, groupId);
    if (!group) {
      return;
    }
    const { qrFieldId } = group.calculatedInfo;
    if (!qrFieldId) {
      return;
    }

    const foundInstance = Object.values(
      yield* select(selectAseFieldInstancesForGroup, {
        groupId,
        parent: null,
        inAssessmentOnly: false,
      }),
    ).find((instance) => instance.results[qrFieldId]?.value === data);
    if (foundInstance) {
      if (
        foundInstance.inAssessment &&
        (!parent ||
          (yield* select(
            selectAseFieldInstanceChildInstanceIsInParentAstAse,
            parent,
            foundInstance.instanceId,
          )))
      ) {
        yield* put(
          doAseOpenFieldInstance({
            instanceId: foundInstance.instanceId,
            parent,
            scrollTo: true,
          }),
        );
      } else {
        yield* put(
          NAVIGATE_MODAL({
            screen: ModalScreens.AseFieldInstance,
            params: {
              groupId,
              isAddingExisting: true,
              instanceId: foundInstance.instanceId,
              parent,
            },
          }),
        );
      }
      return;
    }

    // If no match, ask to add a new one
    if (
      yield* sagaConfirm({
        text:
          `No existing ${group.calculatedInfo.singularName.toLowerCase()} found\n\n` +
          'Create one with that QR code now?',
        confirmText: 'Create',
      })
    ) {
      yield* put(
        NAVIGATE_MODAL({
          screen: ModalScreens.AseFieldInstance,
          params: {
            groupId,
            instanceId: undefined,
            initValues: { [qrFieldId]: data },
            parent,
          },
        }),
      );
    }
  }),

  takeEvery(doAseFieldInstanceSearchBarcode, function* f(action) {
    const { data } = action.payload;
    if (!data) {
      return;
    }

    const foundInstance = yield* select(selectAseFieldInstanceWithQrCode, data);

    if (foundInstance) {
      const isRepeatablePage = navigationIsSelected([
        {
          name: Screens.ROOT_ASEREPEATABLE,
          params: {
            groupId: foundInstance.groupId,
            parent: null,
          },
        },
      ]);
      if (!isRepeatablePage) {
        const isDifferentRepeatablePage = navigationIsSelected([
          {
            name: Screens.ROOT_ASEREPEATABLE,
          },
        ]);
        if (isDifferentRepeatablePage) {
          navigationRef.current?.goBack();
        }
        push(Stacks.ROOT, Screens.ROOT_ASEREPEATABLE, {
          groupId: foundInstance.groupId,
          parent: null,
        });
      }
      if (foundInstance.inAssessment) {
        yield delay(1);
        yield* put(
          doAseOpenFieldInstance({
            instanceId: foundInstance.instanceId,
            parent: null,
            scrollTo: true,
          }),
        );
      } else {
        yield* put(
          NAVIGATE_MODAL({
            screen: ModalScreens.AseFieldInstance,
            params: {
              groupId: foundInstance.groupId,
              isAddingExisting: true,
              instanceId: foundInstance.instanceId,
              parent: null,
            },
          }),
        );
      }
      return;
    }

    // If no match, ask to add a new one
    yield* put(
      ALERT({
        text: 'No element found with this QR code',
      }),
    );
  }),

  takeEvery(doAseFieldInstanceSearchPin, function* f(action) {
    const { id: instanceId, groupId, parent } = action.payload;
    if (!instanceId) {
      return;
    }
    const group = yield* select(selectAseTplFieldGroup, groupId);
    if (!group) {
      return;
    }
    const { pinFieldId } = group.calculatedInfo;
    if (!pinFieldId) {
      return;
    }
    const instance = yield* select(selectAseFieldInstanceAstAse, instanceId);
    if (instance) {
      if (
        instance.inAssessment &&
        (!parent ||
          (yield* select(
            selectAseFieldInstanceChildInstanceIsInParentAstAse,
            parent,
            instanceId,
          )))
      ) {
        yield* put(
          doAseOpenFieldInstance({
            instanceId,
            parent,
            scrollTo: true,
          }),
        );
      } else {
        yield* put(
          NAVIGATE_MODAL({
            screen: ModalScreens.AseFieldInstance,
            params: {
              groupId,
              isAddingExisting: true,
              instanceId,
              parent,
            },
          }),
        );
      }
    }
  }),

  takeEvery(doAseFieldResultsSave, function* f(action) {
    const { results } = action.payload;
    if (yield* select(selectAseIsOnline)) {
      const blKey = randomKey();
      yield* put(SHOW_BLOCKING_LOADER(blKey));
      try {
        if (Object.keys(results).length) {
          yield* put(
            doAseLoadDataFromNewApi({
              response: yield* apiPut<
                EPAssessmentUpdateFields['response'],
                EPAssessmentUpdateFields['post']
              >(http.apiAseSaveFields(yield* select(selectAseId)), {
                results,
                instanceId: null,
                action: null,
                groupId: null,
                parent: null,
                newLiteInstances: {},
              }),
            }),
          );
        }
        yield put(HIDE_BLOCKING_LOADER(blKey));
        yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseFields]));
      } catch (error) {
        yield put(HIDE_BLOCKING_LOADER(blKey));
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }
    yield* saveAssessmentDelta({
      fieldResults: {
        ...results,
      },
    });
  }),

  takeEvery(doAseFieldInstanceSave, function* f(action) {
    const { instance, parent, isAdding, newLiteInstances, isLite } =
      action.payload;
    const { groupId, instanceId } = instance;

    const existingInstance = yield* select(
      selectAseFieldInstanceAse,
      instanceId,
    );

    if (yield* select(selectAseIsOnline)) {
      const blKey = randomKey();
      yield* put(SHOW_BLOCKING_LOADER(blKey));
      try {
        if (isAdding || Object.keys(instance.results).length) {
          yield* put(
            doAseLoadDataFromNewApi({
              response: yield* apiPut<
                EPAssessmentUpdateFields['response'],
                EPAssessmentUpdateFields['post']
              >(http.apiAseSaveFields(yield* select(selectAseId)), {
                results: instance.results,
                instanceId,
                action: instance.action,
                parent,
                groupId,
                newLiteInstances: Object.fromEntries(
                  Object.values(newLiteInstances).map((liteInstance) => [
                    liteInstance.instanceId,
                    {
                      action: liteInstance.action,
                      groupId: liteInstance.groupId,
                      instanceId: liteInstance.instanceId,
                      results: liteInstance.results,
                    },
                  ]),
                ),
              }),
            }),
          );
        }
        yield put(HIDE_BLOCKING_LOADER(blKey));
        yield* put(
          NAVIGATE_MODAL_BACK([
            ModalScreens.AseFieldInstance,
            ModalScreens.AseLightRepeatableInstance,
          ]),
        );
      } catch (error) {
        yield put(HIDE_BLOCKING_LOADER(blKey));
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }

    // Add instance
    yield* call(saveAssessmentDelta, {
      fieldInstances: {
        ...newLiteInstances,
        [instanceId]: existingInstance
          ? {
              ...cloneDeep(existingInstance),
              updatedTs: instance.updatedTs,
              results: instance.results,
              action: instance.action,
            }
          : cloneDeep(instance),
      },
    });

    if (parent) {
      yield* call(modifyChildInstances, parent, {
        addInstanceIds: [instanceId],
        removeInstanceIds: [],
      });
    }

    yield* put(
      NAVIGATE_MODAL_BACK([
        ModalScreens.AseFieldInstance,
        ModalScreens.AseLightRepeatableInstance,
      ]),
    );

    if (!existingInstance) {
      yield delay(1);
      yield* put(
        NAVIGATE_MODAL_BACK([ModalScreens.ASEREPEATABLEINSTANCENEWFROMLIST]),
      );
      if (!isLite) {
        yield delay(250);
        yield* put(
          doAseOpenFieldInstance({
            instanceId,
            parent,
            scrollTo: true,
          }),
        );
      }
      const group = yield* select(selectAseTplFieldGroup, groupId);
      yield* put(doToast(`${group?.calculatedInfo.singularName} Added`));
    }
  }),

  takeEvery(doAseFieldInstanceDuplicate, function* f(action) {
    const { instanceId, parent } = action.payload;
    const instance = yield* select(
      selectAseFieldInstanceAstAseMerged,
      instanceId,
    );
    if (!instance) {
      return;
    }

    const group = (yield* select(selectAseTplFieldGroup, instance.groupId))!;
    if (!group) {
      return;
    }
    const fields = yield* select(selectAseDataFieldFields);

    const skipFieldTypes = [
      FieldTypes.FILE,
      FieldTypes.IMAGE,
      FieldTypes.PIN,
      FieldTypes.QR,
      FieldTypes.GROUP,
    ];

    const initResults: Record<string, FieldResult> = {};
    let newTempRepeatables: Record<string, AseFieldInstance> = {};

    function* addLiteInstances(liteGroupId: string, liteInstanceIds: string[]) {
      const newLiteRepeatableIds: string[] = [];
      const newLiteRepeatables: Record<string, AseFieldInstance> = {};
      const liteGroup = yield* select(selectAseTplFieldGroup, liteGroupId);
      if (!liteGroup) {
        return {
          newLiteRepeatableIds,
          newLiteRepeatables,
        };
      }

      for (const liteInstanceId of liteInstanceIds) {
        const liteInstance = yield* select(
          selectAseFieldInstanceAstAseMerged,
          liteInstanceId,
        );
        if (
          liteInstance &&
          !['delete', 'remove'].includes(liteInstance.action || '')
        ) {
          const liteResults: Record<string, FieldResult> = {};

          for (const liteResult of Object.values(liteInstance.results)) {
            const liteField = fields[liteResult.fieldId];
            if (
              liteResult.action !== 'delete' &&
              liteField &&
              !skipFieldTypes.includes(liteField.type)
            ) {
              liteResults[liteResult.fieldId] = cloneDeep(liteResult);
            }
          }
          if (Object.keys(liteResults).length) {
            const newRepeatableId = uuid();
            newLiteRepeatableIds.push(newRepeatableId);
            newLiteRepeatables[newRepeatableId] = {
              instanceId: newRepeatableId,
              groupId: liteInstance.groupId,
              createdTs: dateToNumber(),
              updatedTs: dateToNumber(),
              results: liteResults,
              action: null,
              // autoId not applicable to light groups
              draft: true,
              autoId: 0,
              draftAutoId: 0,
              checks: {},
            };
          }
        }
      }
      return {
        newLiteRepeatableIds,
        newLiteRepeatables,
      };
    }

    for (const [fieldId, result] of Object.entries(instance.results)) {
      const field = fields[result.fieldId];
      if (
        result.action !== 'delete' &&
        field &&
        !skipFieldTypes.includes(field.type)
      ) {
        if (field.type === FieldTypes.GROUPLIGHT) {
          const { newLiteRepeatables, newLiteRepeatableIds } =
            yield* addLiteInstances(
              field.childGroupId!,
              result.value as string[],
            );
          if (newLiteRepeatableIds.length) {
            newTempRepeatables = {
              ...newTempRepeatables,
              ...newLiteRepeatables,
            };
            initResults[fieldId] = {
              ...result,
              value: newLiteRepeatableIds,
              ts: dateToNumber(),
            };
          }
        } else {
          initResults[fieldId] = { ...result, ts: dateToNumber() };
        }
      }
    }

    const autoIdDraftNext = yield* select(
      selectAseFieldInstanceNextDraftAutoIdForGroup,
      group.id,
    );

    const newInstanceId = uuid();
    yield* put(
      doAseFieldInstanceSave({
        instance: {
          instanceId: newInstanceId,
          reference: '',
          groupId: group.id,
          autoId: 0,
          draftAutoId: autoIdDraftNext,
          createdTs: dateToNumber(),
          updatedTs: dateToNumber(),
          results: initResults,
          action: null,
          draft: true,
          checks: {},
        },
        isAdding: true,
        newLiteInstances: newTempRepeatables,
        parent,
        isLite: false,
      }),
    );
  }),

  takeEvery(doAseFieldInstanceRelink, function* f(action) {
    const { instanceId, parent } = action.payload;

    const assessmentInstance = yield* select(
      selectAseFieldInstanceAseMerged,
      instanceId,
    );
    const assetInstance = yield* select(selectAseFieldInstanceAst, instanceId);

    if (!assetInstance) {
      yield* put(
        CATCH_ERROR({
          error: new Error('doAseFieldInstanceRelink asset instance not found'),
          info: { instanceId },
        }),
      );
      return;
    }

    const group = yield* select(
      selectAseTplFieldGroup,
      assessmentInstance?.groupId || assetInstance.groupId,
    );

    if (!group) {
      yield* put(
        CATCH_ERROR({
          error: new Error('doAseFieldInstanceRelink child group not found'),
          info: { instanceId },
        }),
      );
      return;
    }

    const parentGroup = yield* select(
      selectAseTplFieldGroup,
      (yield* select(selectAseTplFieldToGroupId, parent.fieldId)) || '-1',
    );
    if (!parentGroup) {
      yield* put(
        CATCH_ERROR({
          error: new Error('doAseFieldInstanceRelink parent group not found'),
          info: { instanceId, parent },
        }),
      );
      return;
    }

    const includedInAssessment = !!assessmentInstance;
    const { singularName } = group.calculatedInfo;
    const parentSingularName = parentGroup.repeatable
      ? parentGroup.calculatedInfo.singularName
      : 'Field';

    if (!includedInAssessment) {
      const confirmed = yield* sagaConfirm({
        title: `Relink ${singularName} to ${parentSingularName}`,
        text: `This ${singularName.toLowerCase()} was unlinked in this assessment`,
        confirmText: 'Relink & Add To Assessment',
        altConfirmText: `Relink To ${parentSingularName} Only`,
      });
      if (!confirmed) {
        return;
      }
      if (confirmed === true) {
        if (yield* select(selectAseIsOnline)) {
          const blKey = randomKey();
          yield* put(SHOW_BLOCKING_LOADER(blKey));
          try {
            yield* put(
              doAseLoadDataFromNewApi({
                response: yield* apiPost<
                  EPAssessmentUpdateFieldsAddInstances['response'],
                  EPAssessmentUpdateFieldsAddInstances['post']
                >(
                  http.apiAseSaveFieldsAddInstances(yield* select(selectAseId)),
                  {
                    instanceIds: [instanceId],
                    parent,
                  },
                ),
              }),
            );
            yield put(HIDE_BLOCKING_LOADER(blKey));
          } catch (error) {
            yield put(HIDE_BLOCKING_LOADER(blKey));
            if (isError(error)) {
              yield* put(ALERT_ERROR({ error }));
            }
          }
          return;
        }
        // Include instance in assessment
        yield* call(saveAssessmentDelta, {
          fieldInstances: {
            [assetInstance.instanceId]: {
              ...assetInstance,
              results: {},
              updated_ts: dateToNumber(),
            },
          },
        });
      }
    } else if (
      !(yield* sagaConfirm({
        title: `Relink ${singularName} to ${parentSingularName}`,
        text: `This ${singularName.toLowerCase()} was unlinked in this assessment`,
        confirmText: 'Relink',
      }))
    ) {
      return;
    }

    if (yield* select(selectAseIsOnline)) {
      const blKey = randomKey();
      yield* put(SHOW_BLOCKING_LOADER(blKey));
      try {
        // Link only
        const modifications = yield* getModifiedChildInstances(parent, {
          removeInstanceIds: [],
          addInstanceIds: [instanceId],
        });
        if (modifications) {
          let groupId: string | null = null;
          let results: Record<string, AseFieldResult> | undefined;
          const fieldInstance =
            modifications?.fieldInstances?.[parent.instanceId || -1];
          if (fieldInstance) {
            const fieldResult = fieldInstance.results[parent.fieldId];
            if (fieldResult) {
              groupId = fieldInstance.groupId;
              results = { [parent.fieldId]: fieldResult };
            }
          } else {
            const fieldResult = modifications?.fieldResults?.[parent.fieldId];
            if (fieldResult) {
              results = { [parent.fieldId]: fieldResult };
            }
          }
          if (results) {
            yield* put(
              doAseLoadDataFromNewApi({
                response: yield* apiPut<
                  EPAssessmentUpdateFields['response'],
                  EPAssessmentUpdateFields['post']
                >(http.apiAseSaveFields(yield* select(selectAseId)), {
                  instanceId: parent.instanceId,
                  groupId,
                  results,
                  action: null,
                  parent: null, // parent isn't important
                  newLiteInstances: {},
                }),
              }),
            );
          }
        }
        yield put(HIDE_BLOCKING_LOADER(blKey));
      } catch (error) {
        yield put(HIDE_BLOCKING_LOADER(blKey));
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }

    yield* call(modifyChildInstances, parent, {
      addInstanceIds: [instanceId],
      removeInstanceIds: [],
    });
    yield* put(doToast(`${group.calculatedInfo.singularName} Relinked`));
  }),

  takeEvery(doAseFieldInstanceUnlink, function* f(action) {
    const { instanceId, parent } = action.payload;

    const assessmentInstance = yield* select(
      selectAseFieldInstanceAseMerged,
      instanceId,
    );
    const assetInstance = yield* select(selectAseFieldInstanceAst, instanceId);

    const group = yield* select(
      selectAseTplFieldGroup,
      assessmentInstance?.groupId || assetInstance?.groupId || '-1',
    );

    if (!group) {
      yield* put(
        CATCH_ERROR({
          error: new Error('doAseFieldInstanceUnlink child group not found'),
          info: { instanceId },
        }),
      );
      return;
    }

    const parentGroup = yield* select(
      selectAseTplFieldGroup,
      (yield* select(selectAseTplFieldToGroupId, parent.fieldId)) || '-1',
    );
    if (!parentGroup) {
      yield* put(
        CATCH_ERROR({
          error: new Error('doAseFieldInstanceUnlink parent group not found'),
          info: { instanceId, parent },
        }),
      );
      return;
    }

    let removedInstance: boolean = false;
    let deletedInstance: boolean = false;

    if (assessmentInstance) {
      const isNew = !assessmentInstance.autoId;
      const confirmed = yield* sagaConfirm({
        title: `Unlink ${group.calculatedInfo.singularName} from ${parentGroup.calculatedInfo.singularName}`,
        text: isNew
          ? `Do you want to delete this ${group.calculatedInfo.singularName.toLowerCase()} from RiskBase too. This cannot be undone`
          : `Do you you want to remove this ${group.calculatedInfo.singularName.toLowerCase()} from the assessment too. It will remain available on the asset`,
        confirmText: isNew
          ? 'Unlink & Delete From RiskBase'
          : 'Unlink & Remove From Assessment',
        altConfirmText: `Unlink From ${parentGroup.calculatedInfo.singularName} Only`,
        destructive: true,
      });

      if (!confirmed) {
        return;
      }

      if (yield* select(selectAseIsOnline)) {
        const blKey = randomKey();
        yield* put(SHOW_BLOCKING_LOADER(blKey));
        try {
          // Unlink
          const modifications = yield* getModifiedChildInstances(parent, {
            removeInstanceIds: [assessmentInstance.instanceId],
            addInstanceIds: [],
          });
          if (modifications) {
            let groupId: string | null = null;
            let results: Record<string, AseFieldResult> | undefined;
            const fieldInstance =
              modifications?.fieldInstances?.[parent.instanceId || -1];
            if (fieldInstance) {
              const fieldResult = fieldInstance.results[parent.fieldId];
              if (fieldResult) {
                groupId = fieldInstance.groupId;
                results = { [parent.fieldId]: fieldResult };
              }
            } else {
              const fieldResult = modifications?.fieldResults?.[parent.fieldId];
              if (fieldResult) {
                results = { [parent.fieldId]: fieldResult };
              }
            }
            if (results) {
              yield* put(
                doAseLoadDataFromNewApi({
                  response: yield* apiPut<
                    EPAssessmentUpdateFields['response'],
                    EPAssessmentUpdateFields['post']
                  >(http.apiAseSaveFields(yield* select(selectAseId)), {
                    instanceId: parent.instanceId,
                    groupId,
                    results,
                    action: null,
                    parent: null, // parent isn't important
                    newLiteInstances: {},
                  }),
                }),
              );
            }
          }
          if (confirmed === true) {
            // Also remove / delete
            yield* put(
              doAseLoadDataFromNewApi({
                response: yield* apiPut<
                  EPAssessmentUpdateFields['response'],
                  EPAssessmentUpdateFields['post']
                >(http.apiAseSaveFields(yield* select(selectAseId)), {
                  instanceId: assessmentInstance.instanceId,
                  groupId: assessmentInstance.groupId,
                  action: 'remove',
                  results: {},
                  parent: null, // parent isn't important
                  newLiteInstances: {},
                }),
              }),
            );
          }
          yield put(HIDE_BLOCKING_LOADER(blKey));
        } catch (error) {
          yield put(HIDE_BLOCKING_LOADER(blKey));
          if (isError(error)) {
            yield* put(ALERT_ERROR({ error }));
          }
        }
        return;
      }

      if (confirmed === true) {
        removedInstance = !isNew;
        deletedInstance = isNew;
        yield* saveAssessmentDelta({
          ...(yield* select(
            selectAseFieldInstanceLinkedItems,
            assessmentInstance.instanceId,
          )).reduce<{
            actions: Record<string, null>;
            controls: Record<string, null>;
            questions: Record<string, null>;
            checklistItems: Record<string, null>;
          }>(
            (acc, item) => {
              acc[item.type][item.id] = null;
              return acc;
            },
            {
              actions: {},
              controls: {},
              questions: {},
              checklistItems: {},
            },
          ),
          fieldInstances: {
            [assessmentInstance.instanceId]: {
              ...assessmentInstance,
              updatedTs: dateToNumber(),
              results: {},
              action: isNew ? 'delete' : 'remove',
            },
          },
        });
      }
    } else if (
      !(yield* sagaConfirm({
        title: `Unlink ${group.calculatedInfo.singularName} from ${parentGroup.calculatedInfo.singularName}`,
        text: `The ${group.calculatedInfo.singularName.toLowerCase()} will remain available on the asset`,
        confirmText: 'Unlink',
        destructive: true,
      }))
    ) {
      return;
    }

    if (yield* select(selectAseIsOnline)) {
      const blKey = randomKey();
      yield* put(SHOW_BLOCKING_LOADER(blKey));
      try {
        // Unlink only
        const modifications = yield* getModifiedChildInstances(parent, {
          removeInstanceIds: [instanceId],
          addInstanceIds: [],
        });
        if (modifications) {
          let groupId: string | null = null;
          let results: Record<string, AseFieldResult> | undefined;
          const fieldInstance =
            modifications?.fieldInstances?.[parent.instanceId || -1];
          if (fieldInstance) {
            const fieldResult = fieldInstance.results[parent.fieldId];
            if (fieldResult) {
              groupId = fieldInstance.groupId;
              results = { [parent.fieldId]: fieldResult };
            }
          } else {
            const fieldResult = modifications?.fieldResults?.[parent.fieldId];
            if (fieldResult) {
              results = { [parent.fieldId]: fieldResult };
            }
          }
          if (results) {
            yield* put(
              doAseLoadDataFromNewApi({
                response: yield* apiPut<
                  EPAssessmentUpdateFields['response'],
                  EPAssessmentUpdateFields['post']
                >(http.apiAseSaveFields(yield* select(selectAseId)), {
                  instanceId: parent.instanceId,
                  groupId,
                  results,
                  action: null,
                  parent: null, // parent isn't important
                  newLiteInstances: {},
                }),
              }),
            );
          }
        }
        yield put(HIDE_BLOCKING_LOADER(blKey));
      } catch (error) {
        yield put(HIDE_BLOCKING_LOADER(blKey));
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }

    yield* call(modifyChildInstances, parent, {
      addInstanceIds: [],
      removeInstanceIds: [instanceId],
    });

    yield* put(
      doToast(
        `${group.calculatedInfo.singularName} Unlinked${
          deletedInstance
            ? ' & Deleted'
            : removedInstance
              ? 'Unlinked & Removed'
              : ''
        }`,
      ),
    );
  }),

  takeEvery(doAseFieldInstanceAddManyExisting, function* f(action) {
    const { instanceIds, parent } = action.payload;
    const assetInstances = yield* select(selectAseFieldInstancesAst);
    const assessmentInstances = yield* select(selectAseFieldInstancesAse);

    const validInstanceIds = instanceIds.filter(
      (instanceId) =>
        !!assetInstances[instanceId] || !!assessmentInstances[instanceId],
    );
    if (!validInstanceIds.length) {
      return;
    }

    if (yield* select(selectAseIsOnline)) {
      const blKey = randomKey();
      yield* put(SHOW_BLOCKING_LOADER(blKey));
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPost<
              EPAssessmentUpdateFieldsAddInstances['response'],
              EPAssessmentUpdateFieldsAddInstances['post']
            >(http.apiAseSaveFieldsAddInstances(yield* select(selectAseId)), {
              instanceIds: validInstanceIds,
              parent,
            }),
          }),
        );
        yield put(HIDE_BLOCKING_LOADER(blKey));
      } catch (error) {
        yield put(HIDE_BLOCKING_LOADER(blKey));
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }

    const groupId =
      assetInstances[validInstanceIds[0]!]?.groupId ||
      assessmentInstances[validInstanceIds[0]!]!.groupId!;

    const newInstances = validInstanceIds.reduce<
      Record<string, AseFieldInstance>
    >((acc, instanceId) => {
      const instance = assetInstances[instanceId];
      if (instance && !assessmentInstances[instanceId]) {
        acc[instanceId] = {
          ...instance,
          updatedTs: dateToNumber(),
          results: {},
        };
      }
      return acc;
    }, {});

    const addedCount = Object.keys(newInstances).length;
    if (addedCount) {
      yield* call(saveAssessmentDelta, {
        fieldInstances: newInstances,
      });
    }

    if (parent) {
      yield* call(modifyChildInstances, parent, {
        addInstanceIds: validInstanceIds,
        removeInstanceIds: [],
      });
    }

    if (addedCount) {
      if (addedCount === 1) {
        yield* put(
          doAseOpenFieldInstance({
            instanceId: validInstanceIds[0]!,
            parent,
            scrollTo: true,
          }),
        );
      }

      const group = yield* select(selectAseTplFieldGroup, groupId);
      const singularName = group?.calculatedInfo.singularName || 'Item';
      const name = group?.name || 'Item';
      yield* put(
        doToast(
          pluralise(addedCount, `${singularName} Added`, `{x} ${name} Added`),
        ),
      );
    }
  }),

  takeEvery(doAseLightFieldInstanceDelete, function* f(action) {
    const { parent, instanceId } = action.payload;
    const instance = yield* select(
      selectAseFieldInstanceAstAseMerged,
      instanceId,
    );
    if (!instance) {
      return;
    }

    const astInstance = yield* select(selectAseFieldInstanceAst, instanceId);
    const group = yield* select(selectAseTplFieldGroup, instance.groupId);

    if (
      !(yield* sagaConfirm({
        title: `Delete ${group?.calculatedInfo.singularName}`,
        text:
          `Delete this ${group?.calculatedInfo.singularName.toLowerCase()} from RiskBase` +
          `${!astInstance ? '\n\nThis cannot be undone' : ''}`,
        confirmText: 'Delete',
        destructive: true,
      }))
    ) {
      return;
    }

    if (yield* select(selectAseIsOnline)) {
      const blKey = randomKey();
      yield* put(SHOW_BLOCKING_LOADER(blKey));
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateFieldsDeleteLite['response'],
              EPAssessmentUpdateFieldsDeleteLite['post']
            >(http.apiAseSaveFieldsDeleteLite(yield* select(selectAseId)), {
              instanceId,
            }),
          }),
        );
        yield put(HIDE_BLOCKING_LOADER(blKey));
      } catch (error) {
        yield put(HIDE_BLOCKING_LOADER(blKey));
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }

    const modifications = yield* getModifiedChildInstances(parent, {
      addInstanceIds: [],
      removeInstanceIds: [instanceId],
    });
    yield* saveAssessmentDelta({
      fieldInstances: {
        ...(modifications?.fieldInstances || {}),
        [instance.instanceId]: {
          ...instance,
          results: {},
          updatedTs: dateToNumber(),
          action: 'delete',
        },
      },
      fieldResults: {
        ...(modifications?.fieldResults || {}),
      },
    });
  }),

  takeEvery(doAseLightFieldInstanceUndelete, function* f(action) {
    const { parent, instanceId } = action.payload;
    const instance = yield* select(selectAseFieldInstanceAst, instanceId);
    if (!instance) {
      return;
    }
    if (yield* select(selectAseIsOnline)) {
      yield* put(
        doAseFieldInstanceAddManyExisting({
          instanceIds: [instanceId],
          parent,
        }),
      );
      return;
    }
    const modifications = yield* getModifiedChildInstances(parent, {
      addInstanceIds: [instanceId],
      removeInstanceIds: [],
    });
    yield* saveAssessmentDelta({
      fieldInstances: {
        ...(modifications?.fieldInstances || {}),
        [instance.instanceId]: {
          ...instance,
          results: {},
          updatedTs: dateToNumber(),
          action: null,
        },
      },
      fieldResults: {
        ...(modifications?.fieldResults || {}),
      },
    });
  }),

  takeEvery(doAseSetChildGroups, function* f(action) {
    const { parent, instanceIds } = action.payload;
    if (yield* select(selectAseIsOnline)) {
      const blKey = randomKey();
      yield* put(SHOW_BLOCKING_LOADER(blKey));
      try {
        const modifications = yield* getModifiedChildInstances(parent, {
          setInstanceIds: instanceIds,
        });
        if (modifications) {
          let groupId: string | null = null;
          let results: Record<string, AseFieldResult> | undefined;
          const fieldInstance =
            modifications?.fieldInstances?.[parent.instanceId || -1];
          if (fieldInstance) {
            const fieldResult = fieldInstance.results[parent.fieldId];
            if (fieldResult) {
              groupId = fieldInstance.groupId;
              results = { [parent.fieldId]: fieldResult };
            }
          } else {
            const fieldResult = modifications?.fieldResults?.[parent.fieldId];
            if (fieldResult) {
              results = { [parent.fieldId]: fieldResult };
            }
          }
          if (results) {
            yield* put(
              doAseLoadDataFromNewApi({
                response: yield* apiPut<
                  EPAssessmentUpdateFields['response'],
                  EPAssessmentUpdateFields['post']
                >(http.apiAseSaveFields(yield* select(selectAseId)), {
                  instanceId: parent.instanceId,
                  groupId,
                  results,
                  action: null,
                  parent: null,
                  newLiteInstances: {},
                }),
              }),
            );
          }
        }
        yield put(HIDE_BLOCKING_LOADER(blKey));
      } catch (error) {
        yield put(HIDE_BLOCKING_LOADER(blKey));
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }
    yield* call(modifyChildInstances, parent, {
      setInstanceIds: instanceIds,
    });
  }),

  takeEvery(doAseFieldInstanceDelete, function* f(action) {
    const { instanceId } = action.payload;
    const instance = yield* select(selectAseFieldInstanceAseMerged, instanceId);

    /**
     * @todo If deleting, remove instance from child instances
     * Although, do we need to remove it from local data or is it all handled through views/selectors
     */

    if (!instance) {
      return;
    }

    const group = yield* select(selectAseTplFieldGroup, instance.groupId);
    const isNew = !instance.autoId;

    if (
      !(yield* sagaConfirm({
        title: `${isNew ? 'Delete' : 'Remove'} ${
          group?.calculatedInfo.singularName
        }`,
        text: isNew
          ? `Delete this ${group?.calculatedInfo.singularName.toLowerCase()} from RiskBase. This cannot be undone`
          : `Remove this ${group?.calculatedInfo.singularName.toLowerCase()} from the assessment. It will remain available on the asset`,
        destructive: true,
        confirmText: isNew ? 'Delete' : 'Remove',
      }))
    ) {
      return;
    }

    if (yield* select(selectAseIsOnline)) {
      const blKey = randomKey();
      yield* put(SHOW_BLOCKING_LOADER(blKey));
      try {
        yield* put(
          doAseLoadDataFromNewApi({
            response: yield* apiPut<
              EPAssessmentUpdateFields['response'],
              EPAssessmentUpdateFields['post']
            >(http.apiAseSaveFields(yield* select(selectAseId)), {
              ...instance,
              results: {},
              action: isNew ? 'delete' : 'remove',
              parent: null,
              newLiteInstances: {},
            }),
          }),
        );
        yield put(HIDE_BLOCKING_LOADER(blKey));
      } catch (error) {
        yield put(HIDE_BLOCKING_LOADER(blKey));
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }

    yield* saveAssessmentDelta({
      ...(yield* select(
        selectAseFieldInstanceLinkedItems,
        instance.instanceId,
      )).reduce<{
        actions: Record<string, null>;
        controls: Record<string, null>;
        questions: Record<string, null>;
        checklistItems: Record<string, null>;
      }>(
        (acc, item) => {
          acc[item.type][item.id] = null;
          return acc;
        },
        {
          actions: {},
          controls: {},
          questions: {},
          checklistItems: {},
        },
      ),
      fieldInstances: {
        [instance.instanceId]: {
          ...instance,
          updatedTs: dateToNumber(),
          results: {},
          action: isNew ? 'delete' : 'remove',
        },
      },
    });

    yield* put(
      doToast(
        `${group?.calculatedInfo.singularName} ${
          isNew ? 'Deleted' : 'Removed'
        }`,
      ),
    );
  }),

  takeEvery(doAseFieldInstanceAddAction, function* f(action) {
    const { instanceId, parent } = action.payload;
    const instance = yield* select(selectAseFieldInstanceAseMerged, instanceId);
    if (!instance) {
      return;
    }
    yield* put(
      NAVIGATE_MODAL({
        screen: ModalScreens.AseAction,
        params: {
          id: '',
          parent,
          data: returnDefaultAction({
            questionId: null,
            sectionId: '1',
            fieldInstanceId: instanceId,
            suggestionId: null,
          }),
        },
      }),
    );
  }),

  takeEvery(doAseFieldInstanceAddControl, function* f(action) {
    const { instanceId, parent } = action.payload;
    const instance = yield* select(selectAseFieldInstanceAseMerged, instanceId);
    if (!instance) {
      return;
    }
    yield* put(
      NAVIGATE_MODAL({
        screen: ModalScreens.AseControl,
        params: {
          id: '',
          parent,
          data: returnDefaultControl({
            questionId: null,
            sectionId: '1',
            fieldInstanceId: instanceId,
            suggestionId: null,
          }),
        },
      }),
    );
  }),

  takeEvery(doAseLoadPlans, function* f(action) {
    const assetId = yield* select(selectAseAssetId);
    yield* put(
      doLoadPlans({
        ...action.payload,
        context: {
          context: (yield* select(selectAseIsOnline))
            ? AppContextEnum.remoteAssessment
            : AppContextEnum.localAssessment,
          assetId,
          assessmentId: yield* select(selectAseId),
        },
        plans: Object.entries(yield* select(selectAseAssetPlans)).reduce<
          Record<string, Plan>
        >((acc, [planId, plan]) => {
          acc[planId] = {
            id: plan.id,
            name: plan.name,
            fileId: plan.fileId,
            filePage: plan.filePage,
            fileType: plan.fileType || 'image',
            fileWidth: plan.fileWidth || 0,
            fileHeight: plan.fileHeight || 0,
            pinCount: plan.pinCount,
          };
          return acc;
        }, {}),
        plansEditable: (yield* select(selectAseFeatures)).editassetplans,
      }),
    );
  }),

  takeEvery(doAseApprovePrecheck, function* f() {
    const results = yield* select(selectAseResults);
    const { array: errorArray } = returnValidationErrors({
      groups: yield* select(selectAseDataFieldGroups),
      signatories: yield* select(selectAseTplSignatories),
      requireAllAnswers: (yield* select(selectAseTemplate)).requireAllAnswers,
      visibleQuestionResults: yield* select(selectAseVisibleQuestionResults),
      groupRequiredValues: yield* select(
        selectAseFieldGroupsRequiredFieldValues,
      ),
      signatoryResults: yield* select(selectAseSignatoryResults),
      actions: results.actions,
      controls: results.controls,
    });
    if (errorArray.length) {
      yield* put(doAseShowValidationErrors(true));
      yield delay(1);
      if (
        !(yield* sagaConfirm({
          title: 'Some required information is missing from this assessment',
          text: `${smartText(errorArray.join('\n\n'))}`,
          confirmText: 'Continue to Approve',
        }))
      ) {
        return;
      }
    }

    yield* put(
      NAVIGATE_MODAL({
        screen: ModalScreens.AseStatusApprove,
        params: {},
      }),
    );
  }),

  takeEvery(doAseApprove, function* f(action) {
    const { actionTimescaleUpdateReviewed, actionTimescaleDate, note } =
      action.payload;
    const assessmentId = yield* select(selectAseId);
    try {
      yield* put(SHOW_BLOCKING_LOADER());
      yield* put(
        doAseLoadDataFromNewApi({
          response: yield* apiPost<
            EPAssessmentApprove['response'],
            EPAssessmentApprove['post']
          >(http.API_ASE_APPROVE(assessmentId), {
            actionTimescaleUpdateReviewed,
            actionTimescaleDate,
            note,
          }),
        }),
      );
      yield* put(NAVIGATE_MODAL_BACK());
      yield* put(HIDE_BLOCKING_LOADER());
    } catch (error) {
      yield* put(HIDE_BLOCKING_LOADER());
      if (isError(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
    }
  }),

  takeEvery(doAseUnapprove, function* f(action) {
    const { note } = action.payload;
    const assessmentId = yield* select(selectAseId);
    try {
      yield* put(SHOW_BLOCKING_LOADER());
      yield* put(
        doAseLoadDataFromNewApi({
          response: yield* apiPost<
            EPAssessmentUnapprove['response'],
            EPAssessmentUnapprove['post']
          >(http.API_ASE_UNAPPROVE(assessmentId), {
            note,
          }),
        }),
      );
      yield* put(NAVIGATE_MODAL_BACK());
      yield* put(HIDE_BLOCKING_LOADER());
    } catch (error) {
      yield* put(HIDE_BLOCKING_LOADER());
      if (isError(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
    }
  }),

  takeEvery(doAseUnsubmit, function* f(action) {
    const { notify, note } = action.payload;
    const assessmentId = yield* select(selectAseId);
    try {
      yield* put(SHOW_BLOCKING_LOADER());
      yield* put(
        doAseLoadDataFromNewApi({
          response: yield* apiPost<
            EPAssessmentUnsubmit['response'],
            EPAssessmentUnsubmit['post']
          >(http.API_ASE_UNSUBMIT(assessmentId), {
            notify,
            note,
          }),
        }),
      );
      yield* put(NAVIGATE_MODAL_BACK());
      yield* put(HIDE_BLOCKING_LOADER());
    } catch (error) {
      yield* put(HIDE_BLOCKING_LOADER());
      if (isError(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
    }
  }),

  takeEvery(doAseReorderChildGroups, function* f(action) {
    const { groupId, instanceIds, eventKey } = action.payload;

    const group = yield* select(selectAseTplFieldGroup, groupId);
    const instances = yield* select(selectAseFieldInstancesAstAseMerged);
    const fieldsConfig = yield* select(selectAseTemplateFieldFieldsConfig);
    const fields = yield* select(selectAseDataFieldFields);

    if (!group) {
      return;
    }

    const options: { value: string; name: string }[] = [];

    instanceIds.forEach((instanceId) => {
      const instance = instances[instanceId];
      if (instance) {
        const instanceName = group.fieldIds.reduce<string[]>((acc, fieldId) => {
          // Field must be included in fieldsConfig for the user to see it in this assessment
          if (fieldsConfig[fieldId]) {
            const field = fields[fieldId]!;
            const result = instance.results[fieldId];
            if (result) {
              if (field.type === FieldTypes.OPTION) {
                const optionValues = getOptionFieldResultDisplayValues(
                  field,
                  result,
                  true,
                ).join(', ');
                if (
                  optionValues &&
                  optionValues !== 'Yes' &&
                  optionValues !== 'No'
                ) {
                  acc.push(optionValues);
                }
              } else if (
                field.type === FieldTypes.TEXT ||
                field.type === FieldTypes.NOTE
              ) {
                if (result.value?.length) {
                  acc.push(result.value as string);
                }
              }
            }
          }
          return acc;
        }, []);
        options.push({
          name: instanceName.join(' • '),
          value: instanceId,
        });
      }
    });

    yield* put(
      NAVIGATE_MODAL({
        screen: ModalScreens.REORDER,
        params: {
          eventKey,
          options,
        },
      }),
    );
  }),

  takeEvery(doAseOpenAssetFiles, function* f(action) {
    try {
      const files = yield* select(selectAseFilesAst);
      const isOnline = yield* select(selectAseIsOnline);
      const assetId = yield* select(selectAseAssetId);
      const assessmentId = yield* select(selectAseId);
      yield* put(
        doFilesLoad({
          context: {
            context: isOnline
              ? FilesContextEnum.remoteAssessment
              : FilesContextEnum.localAssessment,
            assetId,
            assessmentId,
          },
          files: Object.values(files).reduce<RBFile[]>((acc, file) => {
            const type = file?.type
              ? getFileTypeFromUntrustedExtension(file.type)
              : undefined;
            if (file && type) {
              acc.push({
                id: file.id,
                name: file.name,
                type,
                timestamp: file.timestamp,
                deletable: file.deletable,
                editable: file.editable,
              });
            }
            return acc;
          }, []),
        }),
      );
      yield* put(
        NAVIGATE_MODAL({
          screen: ModalScreens.FILEMANAGER,
          params: {
            multiSelect: !!action.payload.multiSelect,
            promptMessage: action.payload.promptMessage || '',
            eventKey: action.payload.eventKey,
            limitSelectionToFileGroups:
              action.payload.limitSelectionToFileGroups,
          },
        }),
      );
    } catch (error) {
      if (isError(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
      yield* put(CATCH_ERROR({ error }));
    }
  }),

  takeEvery(doAseSetFlagResult, function* f(action) {
    const { flagId, comment, doDelete } = action.payload;
    const assessmentId = yield* select(selectAseId);
    try {
      yield* put(SHOW_BLOCKING_LOADER());
      yield* put(
        doAseLoadDataFromNewApi({
          response: yield* apiPost<
            EPAssessmentSetFlagResult['response'],
            EPAssessmentSetFlagResult['post']
          >(http.apiAseSaveFlagResult(assessmentId, flagId, doDelete), {
            comment,
          }),
        }),
      );
      yield* put(
        NAVIGATE_MODAL_BACK([ModalScreens.AseFlagUnset, ModalScreens.AseFlag]),
      );
      yield delay(1);
      yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseFlag]));
      yield* put(HIDE_BLOCKING_LOADER());
    } catch (error) {
      yield* put(HIDE_BLOCKING_LOADER());
      if (isError(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
    }
  }),

  takeEvery(doAseSaveSignatory, function* f(action) {
    const { signatoryId, name, signature, timestamp, unavailable } =
      action.payload;
    try {
      yield* put(SHOW_BLOCKING_LOADER());
      if (yield* select(selectAseIsOnline)) {
        throw new Error('Signatories cannot be updated in QC');
      }
      if (!unavailable && (!name || !signature)) {
        throw new Error('A name and signature is required');
      }
      yield* call(saveAssessmentDelta, {
        signatories: {
          [signatoryId]: {
            signatoryId,
            name: unavailable ? '' : name,
            signature: unavailable ? '' : signature,
            unavailable,
            timestamp,
          },
        },
      });
      yield delay(1);
      yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseSignatory]));
      yield* put(HIDE_BLOCKING_LOADER());
      yield* put(doToast('Signatory Saved'));
    } catch (error) {
      yield* put(HIDE_BLOCKING_LOADER());
      if (isError(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
    }
  }),

  takeEvery(doAseDeleteSignatory, function* f(action) {
    const { signatoryId } = action.payload;
    try {
      yield* put(SHOW_BLOCKING_LOADER());
      if (yield* select(selectAseIsOnline)) {
        throw new Error('Signatories cannot be updated in QC');
      }
      yield* call(saveAssessmentDelta, {
        signatories: {
          [signatoryId]: null,
        },
      });
      yield delay(1);
      yield* put(NAVIGATE_MODAL_BACK([ModalScreens.AseSignatory]));
      yield* put(HIDE_BLOCKING_LOADER());
      yield* put(doToast('Signatory Deleted'));
    } catch (error) {
      yield* put(HIDE_BLOCKING_LOADER());
      if (isError(error)) {
        yield* put(ALERT_ERROR({ error }));
      }
    }
  }),
  takeEvery(doAseOpenFindingLocationModal, function* f(action) {
    const { eventKey, value } = action.payload;

    const findingLocations = yield* select(selectAseFindingLocations);

    if (
      !findingLocations.locations.length &&
      !findingLocations.unreviewedLocations.length
    ) {
      yield* put(
        ALERT({
          text:
            'No location suggestions available yet\n\n' +
            'Once actions are added, their locations will appear as suggestions',
        }),
      );
      return;
    }

    const options = [
      ...findingLocations.locations.map((option) => ({
        groupName: 'Actions and Controls',
        name: option,
        internalValue: option,
      })),
      ...findingLocations.unreviewedLocations.map((option) => ({
        groupName: 'Unreviewed Actions and Controls',
        name: option,
        internalValue: option,
      })),
    ];

    yield* put(
      NAVIGATE_MODAL({
        screen: ModalScreens.SELECT,
        params: {
          title: 'Location',
          text: `${pluralise(
            options,
            'Location',
            'Locations',
          )} used in this assessment. Choose one to use here.`,
          options,
          value: value ? [value] : undefined,
          eventKey,
        },
      }),
    );
  }),
];
